import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
// import createPersistedState from 'vuex-persistedstate';

// 서비스 레이어 import 추가
import imageService from '../services/imageService';
import mainImageService from '../services/works/mainImageService';
import additionalImageService from '../services/works/additionalImageService';
import detailImageService from '../services/works/detailImageService';
import koreanLabelService from '../services/works/koreanLabelService';
import pricingService from '../services/works/pricingService';
import seoService from '../services/works/seoService';
import quotationService from '../services/works/quotationService';
import workflowService from '../services/workflowService';
import { 대표매입가 } from '../utils/lotCost';
import { computeMargin } from '../utils/adDomain';
import sizeChartService from '../services/works/sizeChartService';
import bundleOptionService from '../services/works/bundleOptionService';
import { detailAltText } from '../services/works/detailAltText';
import { findOptionTarget } from '../utils/optionTarget';
import { coupangDocForSend } from '../services/works/packageEstimate';
import { assertNotLight, assertUpdateFieldsNotLight, pickLightIds, chunkIds, checkFullResponse, uniqueIds, addOriginDetailImages, isLightDoc, mergeListIntoFull } from '../utils/rocketRegLight';

Vue.use(Vuex)

// 로그인 상태 확인(/api/loginstatus)은 앱 전체에서 1회만 수행하고 결과를 공유한다.
// 라우터 가드와 App.vue가 동시에 필요로 하므로 프라미스를 메모이즈한다.
let loginStatusPromise = null;

// 목록용(_light) 문서를 완전 문서로 받는 중인 id → Promise (같은 id 를 두 번 받지 않으려고 공유)
const fullFetchInflight = new Map();

function updateOptionImageState(option, imageData) {
  console.log('update할 option :', option, imageData);
  if (!option.mainImageStatus) {
    // 이미지 상태가 없으면 새로 생성
    return {
      ...option,
      mainImageStatus: {
        status: 'completed',
        image: imageData.originalUrl || '',
        processedImage: imageData.processedUrl || '',
        dimensions: imageData.dimensions || '', // 못 잼 = 빈 칸(지어낸 크기 0)
        filesize: imageData.filesize || '', // 못 잼 = 빈 칸(지어낸 기본 파일 크기 0)
        textRemoved: imageData.textRemoved || false,
        requestId: imageData.requestId || '' // 요청 ID 추가
      }
    };
  } else {
    // 기존 이미지 상태 업데이트
    return {
      ...option,
      mainImageStatus: {
        ...option.mainImageStatus,
        status: 'completed',
        image: imageData.originalUrl || option.mainImageStatus.image,
        processedImage: imageData.processedUrl || option.mainImageStatus.processedImage,
        dimensions: imageData.dimensions !== undefined ? imageData.dimensions : option.mainImageStatus.dimensions, // 새 그림 못 잼('')이면 옛 그림 크기로 덮지 않음
        filesize: imageData.filesize !== undefined ? imageData.filesize : option.mainImageStatus.filesize, // 새 그림 못 잼('')이면 옛 그림 값으로 덮지 않음
        textRemoved: imageData.textRemoved !== undefined ? imageData.textRemoved : option.mainImageStatus.textRemoved,
        requestId: imageData.requestId || option.mainImageStatus.requestId || '' // 요청 ID 업데이트
      }
    };
  }
}

// ── 수집 중 표시 ──────────────────────────────────────────
// 수집은 확장이 쿠팡 탭 하나를 공유해서 긁는다. A 수집이 도는 중에 B 수집을 시작하면
// 같은 탭에서 B 로 로그인해, A 의 남은 수집이 B 화면을 긁어 A 에 저장될 수 있다.
// 그래서 수집 중에는 계정 전환을 막는데, 메모리에만 두면 새로고침 한 번에 뚫린다.
// 브라우저에 적어 두고 새로고침을 넘어 유지한다.
//
// 확장이 끝을 못 알리는 경우(탭 종료·구버전)에 갇히지 않게 시작시각을 함께 적어
// 오래된 것은 무시한다. 상품DB 수집이 실측 10분대라 넉넉히 잡는다.
const COLLECTING_KEY = 'couplus.collecting';
const COLLECTING_MAX_MS = 60 * 60 * 1000;

function readCollecting() {
  try {
    const raw = JSON.parse(localStorage.getItem(COLLECTING_KEY) || '{}');
    const now = Date.now();
    const live = {};
    Object.keys(raw).forEach(k => {
      if (typeof raw[k] === 'number' && now - raw[k] < COLLECTING_MAX_MS) live[k] = raw[k];
    });
    return live;
  } catch (e) {
    console.error('[수집상태] 읽기 실패', e);
    return {};
  }
}

function writeCollecting(map) {
  try {
    localStorage.setItem(COLLECTING_KEY, JSON.stringify(map));
  } catch (e) {
    console.error('[수집상태] 저장 실패', e);
  }
}

// 탭은 계정별로 저장한다 (공용 PC에서 앞사람 탭이 남지 않도록)
function navTabsKey(state) {
  return 'couplus.navTabs.' + ((state.user && state.user._id) || 'guest');
}

function saveNavTabs(state) {
  try {
    localStorage.setItem(navTabsKey(state), JSON.stringify(state.navTabs.tabs));
  } catch (e) {
    console.error('[navTabs] 탭 저장 실패', e);
  }
}

function loadNavTabs(state) {
  try {
    const raw = localStorage.getItem(navTabsKey(state));
    if (!raw) return [];
    const tabs = JSON.parse(raw);
    if (!Array.isArray(tabs)) return [];
    return tabs
      .filter(t => t && t.name && t.path && t.label)
      .map(t => ({
        name: t.name,
        path: t.path,
        label: t.label,
        pinned: !!t.pinned,
        lastVisited: t.lastVisited || 0
      }));
  } catch (e) {
    console.error('[navTabs] 탭 복원 실패', e);
    return [];
  }
}



// 로켓그로스 개별마진 — growthdb.vue changeMargin 과 같은 함수(adDomain.computeMargin, #112).
//   판매장부와 같은 근거(실제 배송비·입출고비 ÷ 순판매, 지금 팔리는 lot 의 매입가·밀크런)를 basis 로 넣는다.
//   store 를 채우는 모든 길(상품관리·광고·노출추적·자산 타일…)이 growthdbupdate 를 거치므로 여기 한 곳에서 계산하고,
//   basis 가 늦게 오면 growthCostBasisUpdate 가 같은 함수로 다시 계산한다(옛 요율식 값이 남지 않게).
function applyGrowthMargin(item, basisMap) {
  if (!item || !item.매입가) return;
  const basisOf = vid => (basisMap || {})[String(vid)];
  const milkrun = item.밀크런비용 || 0;
  const setMargin = (a, cost, milk) => {
    const b = basisOf(a.vendorItemId);
    a.마진 = computeMargin({ ...a, 매입가: cost, 밀크런비용: milk }, b);
    const totalCost = (b && b.매입가 > 0 ? b.매입가 : cost) + (b && b.밀크런 != null ? b.밀크런 : milk);
    a.마진율 = Math.round(a.마진 / (a.salePrice - a.coupon) * 100) / 100;
    a.ROI = Math.round(a.마진 / (totalCost * 10 / 11) * 100) / 100;
    a.ROAS = Math.round((a.salePrice - a.coupon) / a.마진 * 110) / 100;
  };
  setMargin(item, item.매입가, milkrun);
  (item.returnProducts || []).forEach(a => setMargin(a, a.매입가, milkrun));
  (item.upBundlingProducts || []).forEach(a => setMargin(a, a.매입가, milkrun * (a.upBundlingSize || 1)));
}

// 개별마진 근거값 요청 — growthdbupdate(비어 있지 않은 목록)마다 한 번 받는다. 진행 중이면 그 요청을 같이 기다린다.
let growthCostBasisPromise = null;
function loadGrowthCostBasis(store) {
  const p = axios.post('/api/growth/getUnitCostBasis')
    .then(res => {
      if (growthCostBasisPromise !== p) return;   // 더 새 요청이 있으면 그쪽 결과를 쓴다
      store.commit('growthCostBasisUpdate', res && res.data && res.data.success ? res.data.data : {});
    })
    .catch(err => { console.error('개별마진 근거값 조회 실패:', err); });
  growthCostBasisPromise = p;
  return p;
}

export default new Vuex.Store({
  state: {
    appName: 'COUPLUS',
    logo: require('../assets/images/logo.png'),
    darklogo: require('../assets/images/logo.png'),
    dark: false,
    namespaced: true,
    user: {
      regdate: '',
      name: '',
      _id: '',
      companyid: '',
      email: '',
      phone: '',
      suppliercode: '',
      accesshistory: '',
      auth: {},
      grade: '',
      expireDate: '',
      paydate: '',
      nextpayment: '',
      addAccount: '',
      version: '',
      rankslot: 0,
      rocketRegSlot: 0,
      mustChangePw: false,   // 쿠패스 직원 임시 비밀번호 딱지 — HeaderStyle1 이 보고 변경 창을 강제로 띄운다
    },
    userinit: {
      name: '',
      _id: '',
      companyid: '',
      email: '',
      phone: '',
      suppliercode: '',
      accesshistory: '',
      auth: {},
      regdate: '',
      grade: '',
      expireDate: '',
      paydate: '',
      nextpayment: '',
      addAccount: '',
      version: '',
      rankslot: 0,
      rocketRegSlot: 0,
    },
    polist: [],
    polistDateRange: { startdate: null, enddate: null }, // polist 데이터의 날짜 범위
    exportlist: [],
    productdb: [],
    purchase: [],
    matchpo: [],
    returns: [],
    sales: [],
    supply: [],
    stock: [],
    settings: [],
    invoice: [],
    reqpurchase: [],
    growthdb: [],
    // 옵션ID → 개별마진 근거값(/api/growth/getUnitCostBasis, #112). 비어 있으면 마진은 예전 식(요율 개당)
    growthCostBasis: {},
    growthSales: [],
    rocketSales: [],
    TS: [],
    TF: [],
    TF2: [],
    saveitem: [],
    saveItemStatus: false,
    keywordList: [],
    trafficList: [],
    adSourcingList: [],
    sourcingItems: [], // AI상품소싱 결과
    // 지금 서버로 올라가는 중인 저장 요청 수. 0 이 아니면 계정 전환을 막는다
    // (저장은 '지금 로그인한 계정' 기준으로 쌓이므로 도중에 바꾸면 남은 데이터가 새 계정으로 들어간다)
    pendingLedgerWrites: 0,
    // 확장에서 돌고 있는 수집 항목(itemKey). 수집은 확장이 쿠팡에 로그인해 긁으므로
    // 도중에 계정을 바꾸면 쿠팡 세션이 밀려 앞 수집이 조용히 깨진다
    collectingItems: Object.keys(readCollecting()),
    // 이 탭에서 돌고 있는 작업 화면(예: 로켓등록 대기열). 0 이 아니면 화면 새로고침·CLI 업데이트를 미룬다(판 #308 바쁨 문)
    workingScreens: [],
    // 헤더 메뉴 탭 (고정 최대 5개 + 순환 슬롯, 합쳐서 최대 10개)
    navTabs: {
      tabs: [], // [{ name, path, label, pinned, lastVisited }]
      max: 10,
      maxPinned: 5,
    },
    rocketProducts: [], // 로켓배송 상품 목록
    rocketProductsHiddenTotal: 0, // 목록을 다 못 받았을 때 기간 안 전체 건수(다 받았으면 0)
    selectedRocketProduct: null, // 선택된 로켓배송 상품
    selectedOption: null, // 선택된 옵션
    selectedWorkType: "", // 선택된 작업 유형
    workingImageData: null, // 작업 중인 이미지 데이터
    processing: false, // 처리 중 상태
    progressMessage: '', // 진행 메시지
    // 저장 요청에서 서버가 짝을 못 찾은 옵션이 있었을 때만 채워진다(평소엔 null)
    featureSaveWarning: null,
    // 자동 상품명에서 어린이용 낱말을 뺐을 때만 채워진다(평소엔 null) — 화면이 토스트로 알린다
    seoWordWarning: null,
    workflowStatus: {
      currentTask: null, // 현재 작업
      completedTasks: [], // 완료된 작업
      progress: 0, // 진행률 (0-100)
    },
    waitingDetailHtml: false,
    detailHtmlResults: {},
    // 카테고리 등록현황 데이터
    categoryListData: {
      lastUpdate: '',
      categories: [],
      isLoaded: false
    },
    // SSE 알림 상태
    sseNotifications: {
      quotation_created: 0,    // 견적서 생성 알림 (고객용)
      price_modified: 0,       // 가격수정 알림 (쿠패스용)
      payment_completed: 0,    // 입금완료 알림 (쿠패스용)
      shipment_requested: 0,   // 출고요청 알림 (쿠패스용)
      logistics_payment_requested: 0,  // 물류비 입금요청 알림 (화주용)
      logistics_payment_completed: 0,  // 물류비 입금완료 알림 (쿠패스용)
    },
    sseConnection: null, // SSE 연결 객체
    // 재고관리 캐시
    stockManagement: {
      counts: {},       // { 중국재고: 5, 출고요청: 2, ... } 대시보드 카운트
      overseas: [],     // 해외재고 탭 데이터
      domestic: [],     // 국내재고 탭 데이터 (Inventory 기반)
      pendingInbound: [], // 입고대기 목록 (Reqpurchase 기반)
      lastLoaded: null  // 마지막 로드 timestamp
    },
  },
  mutations: {
    // 재고관리 mutations
    SET_STOCK_COUNTS(state, counts) {
      state.stockManagement.counts = counts;
    },
    SET_STOCK_DATA(state, { tab, data }) {
      if (tab === 'overseas') {
        state.stockManagement.overseas = data;
      } else if (tab === 'domestic') {
        state.stockManagement.domestic = data;
      }
      state.stockManagement.lastLoaded = Date.now();
    },
    UPDATE_STOCK_ITEM(state, { itemId, updates }) {
      const updateInArr = (arr) => {
        const idx = arr.findIndex(item => item._id === itemId);
        if (idx !== -1) Object.assign(arr[idx], updates);
      };
      updateInArr(state.stockManagement.overseas);
      updateInArr(state.stockManagement.domestic);
    },
    REMOVE_STOCK_ITEM(state, { itemId, fromTab }) {
      if (fromTab === 'overseas') {
        state.stockManagement.overseas = state.stockManagement.overseas.filter(item => item._id !== itemId);
      } else if (fromTab === 'domestic') {
        state.stockManagement.domestic = state.stockManagement.domestic.filter(item => item._id !== itemId);
      }
    },
    SET_PENDING_INBOUND(state, items) {
      state.stockManagement.pendingInbound = items;
    },
    REMOVE_PENDING_INBOUND(state, reqpurchaseIds) {
      state.stockManagement.pendingInbound = state.stockManagement.pendingInbound.filter(
        item => !reqpurchaseIds.includes(item._id)
      );
    },
    // 부분 업데이트를 위한 mutation 추가
    updateProductPartial(state, { productId, updateFields }) {
      // 상품 찾기
      const index = state.rocketProducts.findIndex(p => p._id === productId);
      if (index !== -1) {
        const product = state.rocketProducts[index];

        // 점 표기법으로 지정된 필드 업데이트
        Object.keys(updateFields).forEach(key => {
          if (key.includes('.')) {
            // 점 표기법 처리 (예: 'options.0.korName')
            const parts = key.split('.');
            let obj = product;

            // coupangDoc.productName 업데이트 로깅
            if (key === 'coupangDoc.productName') {
              const oldValue = product.coupangDoc?.productName;
              console.log(`🔄 Store coupangDoc.productName업데이트: "${oldValue}" > "${updateFields[key]}"`);
            }

            // startPage.productName 업데이트 로깅
            if (key.includes('startPage.productName')) {
              const docIndex = parts[1]; // jsonDocument 인덱스
              const oldValue = product.coupangDoc?.jsonDocument?.[docIndex]?.startPage?.productName;
              console.log(`🔄 Store startPage.productName업데이트 [${docIndex}]: "${oldValue}" > "${updateFields[key]}"`);
            }

            for (let i = 0; i < parts.length - 1; i++) {
              const part = parts[i];
              // 배열 인덱스 처리
              if (!isNaN(part) && Array.isArray(obj)) {
                obj = obj[parseInt(part)];
              } else {
                if (!obj[part]) obj[part] = {};
                obj = obj[part];
              }
            }
            obj[parts[parts.length - 1]] = updateFields[key];
          } else {
            // 일반 필드 업데이트
            product[key] = updateFields[key];
          }
        });

        // 변경 감지를 위해 배열 요소 교체
        Vue.set(state.rocketProducts, index, { ...product });

        // 선택된 상품이 업데이트된 상품이면 선택된 상품도 업데이트
        if (state.selectedRocketProduct && state.selectedRocketProduct._id === productId) {
          state.selectedRocketProduct = state.rocketProducts[index];
        }
      }
    },

    // 상세 이미지 구조 단순화를 위한 mutation
    updateDetailImageStructure(state, { productId, imageData }) {
      // 상품 찾기
      const index = state.rocketProducts.findIndex(p => p._id === productId);
      if (index !== -1) {
        const product = state.rocketProducts[index];

        // 이미지 구조 업데이트
        if (imageData.originalDetailImages) {
          product.originalDetailImages = imageData.originalDetailImages; // 원본 이미지 (1688 이미지)
        }

        if (imageData.processedDetailImages) {
          product.processedDetailImages = imageData.processedDetailImages; // 처리된 이미지 (AI 번역/편집)
        }

        if (imageData.finalDetailImage) {
          product.finalDetailImage = imageData.finalDetailImage; // 최종 이미지 (coupangDoc용)
        }

        // 상태 업데이트
        if (imageData.detailImageStatus) {
          product.detailImageStatus = imageData.detailImageStatus;
        }

        // 변경 감지를 위해 배열 요소 교체
        Vue.set(state.rocketProducts, index, { ...product });

        // 선택된 상품이 업데이트된 상품인 경우 선택된 상품도 업데이트
        if (state.selectedRocketProduct && state.selectedRocketProduct._id === productId) {
          state.selectedRocketProduct = state.rocketProducts[index];
        }
      }
    },

    ledgerWriteStart(state) {
      state.pendingLedgerWrites++;
    },
    collectStart(state, itemKey) {
      if (!itemKey) return;
      if (!state.collectingItems.includes(itemKey)) state.collectingItems.push(itemKey);
      const map = readCollecting();
      map[itemKey] = Date.now();
      writeCollecting(map);
    },
    collectEnd(state, itemKey) {
      const i = state.collectingItems.indexOf(itemKey);
      if (i !== -1) state.collectingItems.splice(i, 1);
      const map = readCollecting();
      delete map[itemKey];
      writeCollecting(map);
    },
    workStart(state, key) {
      if (key && !state.workingScreens.includes(key)) state.workingScreens.push(key);
    },
    workEnd(state, key) {
      const i = state.workingScreens.indexOf(key);
      if (i !== -1) state.workingScreens.splice(i, 1);
    },
    ledgerWriteEnd(state) {
      state.pendingLedgerWrites = Math.max(0, state.pendingLedgerWrites - 1);
    },
    // 계정 보관함에서 꺼낸 조각을 그대로 얹는다 (storeSnapshot.js).
    // 화면들이 "store 에 없으면 서버에서 받는다"로 되어 있어, 채워 넣으면 받지 않는다
    restoreSnapshot(state, payload) {
      if (!payload) return;
      Object.keys(payload).forEach(k => {
        if (k in state) state[k] = payload[k];
      });
    },
    resetState(state) {
      // 기본 state 객체의 깊은 복사본을 만들어서 현재 state를 덮어씁니다
      const defaultState = {
        appName: 'COUPLUS',
        logo: require('../assets/images/logo.png'),
        darklogo: require('../assets/images/logo.png'),
        dark: false,
        namespaced: true,
        user: {
          regdate: '',
          name: '',
          _id: '',
          companyid: '',
          email: '',
          phone: '',
          suppliercode: '',
          accesshistory: '',
          auth: {},
          grade: '',
          expireDate: '',
          paydate: '',
          nextpayment: '',
          addAccount: '',
          version: '',
          rankslot: 0,
          rocketRegSlot: 0,
          mustChangePw: false,
        },
        userinit: {
          name: '',
          _id: '',
          companyid: '',
          email: '',
          phone: '',
          suppliercode: '',
          accesshistory: '',
          auth: {},
          regdate: '',
          grade: '',
          expireDate: '',
          paydate: '',
          nextpayment: '',
          addAccount: '',
          version: '',
          rankslot: 0,
          rocketRegSlot: 0,
        },
        polist: [],
        exportlist: [],
        productdb: [],
        purchase: [],
        matchpo: [],
        returns: [],
        sales: [],
        supply: [],
        stock: [],
        settings: [],
        invoice: [],
        reqpurchase: [],
        growthdb: [],
        growthCostBasis: {},
        growthSales: [],
        rocketSales: [],
        TS: [],
        TF: [],
        TF2: [],
        saveitem: [],
        saveItemStatus: false,
        keywordList: [],
        trafficList: [],
        adSourcingList: [],
        stockManagement: { counts: {}, overseas: [], domestic: [], lastLoaded: null },
        // 아래도 계정 데이터인데 빠져 있었다. 계정을 바꿔 로그인하면 앞 계정 것이 그대로 보인다
        sourcingItems: [],
        // 수집은 계정을 바꿔도 확장에서 계속 돈다. 로그인/전환으로 초기화될 때도
        // 브라우저에 적어둔 것을 그대로 읽어야 가드가 유지된다
        collectingItems: Object.keys(readCollecting()),
        rocketProducts: [],
        rocketProductsHiddenTotal: 0,
        selectedRocketProduct: null,
        selectedOption: null,
        categoryListData: { lastUpdate: '', categories: [], isLoaded: false },
      };

      Object.keys(defaultState).forEach(key => {
        state[key] = JSON.parse(JSON.stringify(defaultState[key]));
      });
    },
    userupdate(state, payload) {
      function deepClone(obj) {
        if (obj === null || typeof obj !== "object") {
          return obj
        }

        const result = Array.isArray(obj) ? [] : {}

        for (let key of Object.keys(obj)) {
          result[key] = deepClone(obj[key])
        }

        return result
      }
      state.user.regdate = payload.regdate;
      state.user.name = payload.name;
      state.user.accesshistory = payload.accesshistory;
      state.user._id = payload._id;
      state.user.companyid = payload.companyid;
      state.user.email = payload.email;
      state.user.phone = payload.phone;
      state.user.suppliercode = payload.suppliercode;
      state.user.grade = payload.grade;
      state.user.auth = deepClone(payload.auth);
      state.user.addAccount = payload.addAccount;
      state.user.expireDate = payload.expireDate;
      state.user.paydate = payload.paydate;
      state.user.nextpayment = payload.nextpayment;
      state.user.expireDate = payload.expireDate;
      state.user.version = payload.version;
      state.user.rankslot = payload.rankslot;
      state.user.rocketRegSlot = payload.rocketRegSlot;
      // 여기는 필드를 골라 담는다 — 빠뜨리면 서버가 내려줘도 화면에서 사라진다(첫 로그인 비번변경 창이 안 뜬 원인)
      state.user.mustChangePw = payload.mustChangePw === true;
    },
    userpaymentstatusupdate(state, payload) {
      state.user.nextpayment = payload.nextpayment;
      // state.user.paydate = payload.paydate;
    },
    userauthupdate(state, payload) {
      function deepClone(obj) {
        if (obj === null || typeof obj !== "object") {
          return obj
        }

        const result = Array.isArray(obj) ? [] : {}

        for (let key of Object.keys(obj)) {
          result[key] = deepClone(obj[key])
        }

        return result
      }
      state.user.auth = deepClone(payload.auth);
    },
    dbupdate(state, payload) {
      console.log('store update')
      // if (payload.polist.length != 0){
      //   var temp = payload.polist;
      //   var arrangecnt = 0;
      //   var notarrangecnt = 0;
      //   var pstockcnt = 0;
      //   var rstockcnt = 0;
      //   var tempstock = payload.stock;

      //   temp.forEach(e => {
      //     e.발주세부내역.forEach(ele => {
      //       arrangecnt = 0;
      //       notarrangecnt = 0;
      //       pstockcnt = 0;
      //       rstockcnt = 0;
      //       if (payload.stock.length != 0){
      //         tempstock.forEach(element => {
      //           if(element.바코드 == ele.바코드){
      //             if(element.배치발주번호 == e.발주번호){
      //               arrangecnt++
      //             } else {
      //               if(element.배치발주번호 == ''){
      //                 if(element.Stockinfo == 'stock') {
      //                   notarrangecnt++
      //                 } else {
      //                   if(element.Stockinfo == 'Pstock') {
      //                     pstockcnt++
      //                   } else {
      //                     if(element.Stockinfo == 'Rstock') {
      //                       rstockcnt++
      //                     }
      //                   }
      //                 }
      //               }
      //             }
      //           }
      //         })
      //       }
      //       payload.productdb.some(el => {
      //         if(el.바코드 == ele.바코드) {
      //           if(el.구매링크 == '사입'){
      //             ele.사입재고수량 = ele.발주수량;
      //           } else {
      //             ele.사입재고수량 = 0;
      //           }
      //           return (el.바코드 == ele.바코드)
      //         }
      //       })


      //       ele.발주수량 = parseInt(ele.발주수량);
      //       ele.입고수량 = parseInt(ele.입고수량);
      //       ele.확정수량 = parseInt(ele.확정수량);
      //       ele.배치수량 = arrangecnt;
      //       ele.필요수량 = parseInt(ele.확정수량) - arrangecnt;
      //       ele.미배치재고수량 = notarrangecnt;
      //       ele.구매완료수량 = pstockcnt;
      //       ele.회송예정수량 = rstockcnt;

      //     })
      //   });

      //   state.polist = temp;
      // } else {
      //   state.polist = payload.polist;
      // }
      state.polist = payload.polist;
      state.productdb = payload.productdb;
      state.purchase = payload.purchase;
      state.returns = payload.returns;
      state.exportlist = payload.exportlist;
      state.stock = payload.stock;
      state.settings = payload.settings;
      state.invoice = payload.invoice;
      state.reqpurchase = payload.reqpurchase;
      console.log('success DbUpdate');
    },
    initDb(state) {
      state.polist = [];
      state.productdb = [];
      state.purchase = [];
      state.returns = [];
      state.exportlist = [];
      state.stock = [];
      state.settings = [];
      state.invoice = [];
      state.reqpurchase = [];
      console.log('@@@init Db success', state.polist, state.productdb, state.purchase, state.returns, state.exportlist, state.stock, state.invoice, state.reqpurchase);
    },
    // SSE 알림 관련 mutations
    sseSetConnection(state, connection) {
      state.sseConnection = connection;
    },
    sseIncrementNotification(state, type) {
      if (state.sseNotifications[type] !== undefined) {
        state.sseNotifications[type]++;
      }
    },
    sseClearNotification(state, type) {
      if (state.sseNotifications[type] !== undefined) {
        state.sseNotifications[type] = 0;
      }
    },
    sseClearAllNotifications(state) {
      state.sseNotifications.quotation_created = 0;
      state.sseNotifications.price_modified = 0;
      state.sseNotifications.payment_completed = 0;
      state.sseNotifications.logistics_payment_requested = 0;
      state.sseNotifications.logistics_payment_completed = 0;
    },
    growthSalesUpdate(state, payload) {
      state.growthSales = payload
    },
    rocketSalesUpdate(state, payload) {
      state.rocketSales = payload
    },
    growthCostBasisUpdate(state, payload) {
      state.growthCostBasis = payload || {};
      // 이미 들어와 있는 목록도 같은 근거로 다시 계산한다(먼저 채운 화면이 옛 값을 남기지 않게)
      (state.growthdb || []).forEach(item => applyGrowthMargin(item, state.growthCostBasis));
    },
    growthdbupdate(state, payload) {
      // payload로 받은 데이터 가공
      const processedData = payload.map(item => {
        // 구매정보가 없는 경우 기본 구매정보 생성
        if (!item.구매정보 || item.구매정보.length == 0) {
          item.구매정보 = [{
            checked: false,
            showspinner: false,
            바코드: item.barcode || item.바코드,
            상품명: item.productName || item.상품명,
            상품명init: item.productName || item.상품명init,
            구매링크: undefined,
            구매링크init: undefined,
            옵션1_중국어: undefined,
            옵션2_중국어: undefined,
            옵션이미지: undefined,
            매칭상태: '매칭필요',
            상품매칭: {
              옵션1_중국어: [],
              옵션2_중국어: [],
            },
            구매재고: '',
            구매요청수량: '',
            판매구성수량: 1,
            묶음구성여부: false,
            묶음구성수량: '',
            묶음대상바코드: '',
            신고영문명: '',
            신고가격: '',
            HSCODE: '',
            진행현황: '구매전',
            재고동봉: true,
            등록이미지: item.optionImageUrl || item.등록이미지,
            요청사항: '요청등록',
            reqtype: '제트배송',
            sizeX: item.sizeInfo ? item.sizeInfo.width : 0,
            sizeY: item.sizeInfo ? item.sizeInfo.length : 0,
            sizeZ: item.sizeInfo ? item.sizeInfo.height : 0,
            weight: item.sizeInfo ? item.sizeInfo.weight : 0,
            요청내역: {
              default: true,
              poarrange: false,
              한글표시사항: true,
              barcode: true,
              sticker: false,
              sewing: false,
              stamp: false,
              tag: false,
              reqcontent: '',
              opp: false,
              LDPE: false,
              airpacking: false,
              exportType: 'box',
              destination: 'coupang',
              masking: false,
              auto: true,
            },
            한글표시사항: {
              제품명: item.productName || item.상품명,
              '수입원/판매원': '',
              제조원: '',
              제조국: '',
              내용량: '',
              '원료명및성분명(재질)': '',
              상품유형: '',
              사용시주의사항: '',
              사용기준: '',
              custom: '',
            },
            polists: [],
            selectpo: '',
          }];
          item.구매정보여부 = false;
        }

        // 상품명 설정
        item.상품명 = item.skuName;

        // 매입가 계산
        // ⚠ '배열의 마지막 행' 이 아니라 '가격이 적힌 마지막 행' 이다.
        //   입고내역이 깔아주는 뼈대 행은 날짜·수량만 있고 가격이 비어 있어서,
        //   그걸 그대로 읽으면 대표 매입가가 0 이 된다(lotCost.대표매입가 주석 참조).
        const 대표 = 대표매입가(item.매입정보);
        if (대표 > 0) {
          item.매입가 = 대표;
          if (item.returnProducts && item.returnProducts.length > 0) {
            item.returnProducts.forEach(a => {
              a.매입가 = 대표;
            });
          }
          if (item.upBundlingProducts && item.upBundlingProducts.length > 0) {
            item.upBundlingProducts.forEach(a => {
              const bundleSize = a.upBundlingSize || 1;
              a.매입가 = 대표 * bundleSize;
            });
          }
        } else {
          item.매입가 = "";
          if (item.returnProducts && item.returnProducts.length > 0) {
            item.returnProducts.forEach(a => {
              a.매입가 = "";
            });
          }
          if (item.upBundlingProducts && item.upBundlingProducts.length > 0) {
            item.upBundlingProducts.forEach(a => {
              a.매입가 = "";
            });
          }
        }

        applyGrowthMargin(item, state.growthCostBasis);

        return item;
      });

      // 정렬
      processedData.sort((a, b) => b.gmvForLast30Days - a.gmvForLast30Days);

      // 처리된 데이터를 state에 저장
      state.growthdb = processedData;
    },
    growthdbupdateOne(state, payload) {
      for (let i = 0; i < state.growthdb.length; i++) {
        if (state.growthdb[i].barcode === payload.barcode) {
          // 방법 1: Object.assign 사용
          Object.assign(state.growthdb[i], payload);

          // 방법 2: Vue.set()을 사용 (Vue3 이전에서는 Vue.set을 사용해야 반응성 유지 가능)
          // Vue.set(state.growthdb, i, payload);

          console.log(state.growthdb[i]);
          console.log(payload);
          return;
        }
      }
    },
    getAdSourcingListUpdate(state, payload) {
      state.adSourcingList = payload
    },
    reqpurchaseupdate(state, payload) {
      state.reqpurchase = payload;
    },
    polistupdate(state, payload) {
      // payload가 객체이고 data와 dateRange를 포함하는 경우
      if (payload && payload.data !== undefined && payload.dateRange !== undefined) {
        state.polist = payload.data;
        state.polistDateRange = payload.dateRange;
      } else {
        // 기존 방식 호환 (배열만 전달되는 경우)
        state.polist = payload;
      }
    },
    productdbupdate(state, payload) {
      state.productdb = payload;
    },
    invoiceupdate(state, payload) {
      state.invoice = payload;
    },
    settingsupdate(state, payload) {
      state.settings = payload;
    },
    settingsupdateparameter(state, payload) {
      state.settings[0][payload.key] = payload.value;
    },
    stockinsert(state, payload) {
      state.stock.push(payload)
    },
    stockdelete(state, payload) {
      //payload : arr, remove target objects in array, including "_id"

      payload.forEach(e => {
        state.stock = state.stock.filter(ele => ele._id != e._id)
      })

    },
    exportlistupdate(state, payload) {
      state.exportlist = payload
    },
    purchaseupdate(state, payload) {
      state.purchase = payload
    },
    updatepurchaseitem(state, payload) {
      state.purchase.find(e => e._id == payload._id).주문수량 = payload.주문수량;
      state.purchase.find(e => e._id == payload._id).운송장번호 = payload.운송장번호;
    },
    updateboxqty(state, payload) {
      state.productdb.find(e => e.바코드 == payload.바코드)['1박스인입수량'] = payload['1박스인입수량'];
    },
    updateleadtime(state, payload) {
      state.productdb.find(e => e.바코드 == payload.바코드)['입고리드타임'] = payload['입고리드타임'];
    },
    deletepurchase(state, payload) {
      payload.forEach(e => {
        state.purchase = deleteindexfromarray(state.purchase, state.purchase.findIndex(ele => equal(ele, e)));
      })

      function deleteindexfromarray(array, index) {
        return array.slice(0, index).concat(array.slice(index + 1))
      }

      function equal(k1, k2) {
        JSON.stringify(k1) === JSON.stringify(k2)
      }

    },
    stockupdate(state, payload) {
      state.stock = payload
    },
    salesupdate(state, payload) {
      state.sales = payload
    },
    supplyupdate(state, payload) {
      state.supply = payload
    },
    layoutModeCommit(state, payload) {
      state.dark = payload
      if (!payload) {
        state.logo = require('../assets/images/logo.png')
      } else {
        state.logo = require('../assets/images/logo.png')
      }
    },
    updateTS(state, payload) {
      state.TS = payload;
    },
    setSourcingItems(state, payload) {
      state.sourcingItems = payload;
    },
    // 헤더 메뉴 탭 ------------------------------------------------------
    NAVTAB_OPEN(state, { name, path, label }) {
      if (!name || !path || !label) return;
      const nav = state.navTabs;
      const exist = nav.tabs.find(t => t.name === name);
      if (exist) {
        exist.path = path;
        exist.label = label;
        exist.lastVisited = Date.now();
        saveNavTabs(state);
        return;
      }
      nav.tabs.push({ name, path, label, pinned: false, lastVisited: Date.now() });
      // 슬롯 초과 시 고정 안 된 탭 중 가장 오래 안 본 것부터 밀어냄
      while (nav.tabs.length > nav.max) {
        const victim = nav.tabs
          .filter(t => !t.pinned && t.name !== name)
          .sort((a, b) => a.lastVisited - b.lastVisited)[0];
        if (!victim) break; // 밀어낼 대상이 없으면 중단 (무한루프 방지)
        nav.tabs.splice(nav.tabs.indexOf(victim), 1);
      }
      saveNavTabs(state);
    },
    NAVTAB_CLOSE(state, name) {
      const nav = state.navTabs;
      const idx = nav.tabs.findIndex(t => t.name === name);
      if (idx === -1) return;
      nav.tabs.splice(idx, 1);
      saveNavTabs(state);
    },
    NAVTAB_TOGGLE_PIN(state, name) {
      const nav = state.navTabs;
      const tab = nav.tabs.find(t => t.name === name);
      if (!tab) return;
      // 고정 상한 초과는 무시 (안내는 호출한 컴포넌트가 담당)
      if (!tab.pinned && nav.tabs.filter(t => t.pinned).length >= nav.maxPinned) return;
      tab.pinned = !tab.pinned;
      // 고정 탭은 항상 왼쪽에 모아둔다
      nav.tabs.splice(nav.tabs.indexOf(tab), 1);
      const lastPinned = nav.tabs.map(t => t.pinned).lastIndexOf(true);
      nav.tabs.splice(tab.pinned ? lastPinned + 1 : nav.tabs.length, 0, tab);
      saveNavTabs(state);
    },
    NAVTAB_RESTORE(state) {
      state.navTabs.tabs = loadNavTabs(state).slice(0, state.navTabs.max);
    },
    updateTF(state, payload) {
      state.TF = payload;
    },
    updateTF2(state, payload) {
      state.TF2 = payload;
    },
    updateSaveItem(state, payload) {
      state.saveitem = payload;
    },
    updateSaveItemStatus(state, payload) {
      state.saveItemStatus = payload;
    },
    setKeywordList(state, payload) {
      state.keywordList = payload;
    },
    updateKeywordList(state, payload) {
      if (payload.arr.length == 0) {
        return
      }
      if (payload.keyword == 'Default') {
        state.keywordList = state.keywordList.filter(e => e.keywordGroup)
        state.keywordList = state.keywordList.concat(payload.arr)
      } else {
        state.keywordList = state.keywordList.filter(e => e.keywordGroup !== payload.keyword)
        state.keywordList = state.keywordList.concat(payload.arr)
        console.log(state.keywordList)
      }
    },
    updateAllKeywordList(state, payload) {
      state.keywordList = payload;
    },
    updateTrafficList(state, payload) {
      state.trafficList = payload;
    },
    // 로켓배송 관련 mutations
    SET_ROCKET_PRODUCTS_HIDDEN_TOTAL(state, total) {
      state.rocketProductsHiddenTotal = Number(total) || 0;
    },
    SET_ROCKET_PRODUCTS(state, products) {
      // 안전성 검사 추가
      if (!Array.isArray(products)) {
        console.error('❌ SET_ROCKET_PRODUCTS: products가 배열이 아닙니다:', typeof products, products);
        return;
      }

      // 목록 재조회(view:'list')가 작업 중 받아 둔 완전 문서를 목록용으로 되돌리지 않게 — 완전 문서는 유지하고 목록 칸만 새 값으로
      const fullById = new Map();
      (state.rocketProducts || []).forEach(p => { if (p && p._id && !isLightDoc(p)) fullById.set(String(p._id), p); });
      const merged = fullById.size
        ? products.map(p => (p && p._light && fullById.has(String(p._id))) ? mergeListIntoFull(fullById.get(String(p._id)), p) : p)
        : products;

      console.log(`✅ SET_ROCKET_PRODUCTS: ${products.length}개 상품 설정`);
      state.rocketProducts = merged;
    },

    ADD_ROCKET_PRODUCT(state, product) {
      // 중복 확인 후 추가
      const existingIndex = state.rocketProducts.findIndex(p => p.registrationId === product.registrationId);
      if (existingIndex === -1) {
        state.rocketProducts.push(product);
        console.log(`✅ ADD_ROCKET_PRODUCT: ${product.registrationId} 추가됨`);
      } else {
        console.log(`⚠️ ADD_ROCKET_PRODUCT: ${product.registrationId} 이미 존재함`);
      }
    },

    SET_SELECTED_ROCKET_PRODUCT(state, product) {
      state.selectedRocketProduct = product;
    },

    SET_SELECTED_OPTION(state, option) {
      state.selectedOption = option;
    },

    SET_SELECTED_WORK_TYPE(state, workType) {
      state.selectedWorkType = workType;
    },

    // 목록용 문서를 완전 문서로 교체(같은 _id 자리)
    REPLACE_ROCKET_PRODUCT_FULL(state, fullProduct) {
      const id = String(fullProduct && fullProduct._id);
      const index = state.rocketProducts.findIndex(p => String(p._id) === id);
      if (index !== -1) Vue.set(state.rocketProducts, index, fullProduct);
      // 모달에서 고치던 완전 문서는 덮지 않는다 — 목록용일 때만 교체
      if (state.selectedRocketProduct && String(state.selectedRocketProduct._id) === id && isLightDoc(state.selectedRocketProduct)) {
        state.selectedRocketProduct = fullProduct;
      }
    },
    UPDATE_ROCKET_PRODUCT(state, updatedProduct) {
      console.log('🔄 UPDATE_ROCKET_PRODUCT 뮤테이션 실행');

      const index = state.rocketProducts.findIndex(p => p.registrationId === updatedProduct.registrationId);
      if (index !== -1) {
        // 원본 이미지 필드 보존 (추가나 업데이트되지 않았을 경우)
        if (!updatedProduct.originDetailImages && state.rocketProducts[index].originDetailImages) {
          updatedProduct.originDetailImages = state.rocketProducts[index].originDetailImages;
        }

        // coupangDoc 보존 및 동기화 검증 (신규 코드)
        if (updatedProduct.options && updatedProduct.options.length > 0 &&
            state.rocketProducts[index].options && state.rocketProducts[index].options.length > 0) {

          console.log('⚙️ UPDATE_ROCKET_PRODUCT 뮤테이션: 옵션 coupangDoc 보존 및 동기화 검증');

          // 각 옵션별로 coupangDoc 확인 및 보존
          updatedProduct.options.forEach(newOption => {
            // 기존 상태에서 해당 옵션 찾기
            const existingOption = state.rocketProducts[index].options.find(
              opt => opt.optionNumber === newOption.optionNumber
            );

            // coupangDoc 보존 로직 (목록용 옵션은 coupangDoc 이 잘려 있어 복원하지 않는다)
            if (existingOption && !existingOption._light && !newOption.coupangDoc && existingOption.coupangDoc) {
              console.log(`옵션 ${newOption.optionNumber}: 뮤테이션에서 coupangDoc 복원`);
              newOption.coupangDoc = JSON.parse(JSON.stringify(existingOption.coupangDoc));
            }

            // 상품명 동기화 확인 (SEO 정보가 설정된 경우)
            if (newOption.coupangDoc?.jsonDocument?.[0]?.startPage && updatedProduct.seo?.productName) {
              const expectedName = newOption.korName
                // 허브 상품명 — 상품명에 같은 묶음 수가 있으면 옵션명 «(N개묶음)» 뗌(아래 저장 길과 같은 규칙 · 윈 3452 PR261021-56DBDD)
                ? `${updatedProduct.seo.productName}, ${bundleOptionService.hubOptionName(updatedProduct.seo.productName, newOption.korName, updatedProduct)}`
                : updatedProduct.seo.productName;

              const actualName = newOption.coupangDoc.jsonDocument[0].startPage.productName;

              if (actualName !== expectedName) {
                console.log(`⚠️ 옵션 ${newOption.optionNumber}: 상품명 불일치 감지 및 수정`);
                console.log(`🔄 UPDATE_ROCKET_PRODUCT startPage.productName업데이트: "${actualName}" > "${expectedName}"`);

                // 상품명 업데이트
                newOption.coupangDoc.jsonDocument[0].startPage.productName = expectedName;

                // modelNumber도 업데이트 (존재하는 경우)
                if (newOption.coupangDoc.jsonDocument[0].productPage) {
                  const oldModelNumber = newOption.coupangDoc.jsonDocument[0].productPage.modelNumber;
                  newOption.coupangDoc.jsonDocument[0].productPage.modelNumber = expectedName;
                  console.log(`🔄 UPDATE_ROCKET_PRODUCT modelNumber업데이트: "${oldModelNumber}" > "${expectedName}"`);
                }
              }
            }
          });
        }

        // Vue의 반응성을 위해 배열 변이 메소드 사용
        Vue.set(state.rocketProducts, index, updatedProduct);

        // 선택된 상품이 업데이트된 상품이면 선택된 상품도 업데이트
        if (state.selectedRocketProduct && state.selectedRocketProduct.registrationId === updatedProduct.registrationId) {
          state.selectedRocketProduct = updatedProduct;
        }

        console.log('✅ UPDATE_ROCKET_PRODUCT 뮤테이션 완료');
      } else {
        console.warn('⚠️ UPDATE_ROCKET_PRODUCT: 업데이트할 상품을 찾을 수 없음:', updatedProduct.registrationId);
      }
    },
    // index.js - UPDATE_OPTION_IMAGE 뮤테이션 수정

    UPDATE_OPTION_IMAGE(state, { registrationId, optionNumber, imageData }) {
      console.log(`UPDATE_OPTION_IMAGE - 옵션 ${optionNumber} - 이미지 데이터:`, imageData.processedUrl);
      // 등록ID 로 그 상품을 고른다 — 옵션 번호만으로 찾으면 같은 번호의 딴 상품(분리분 등)을 덮는다
      const target = findOptionTarget(state.rocketProducts, registrationId, optionNumber);
      if (!target) {
        console.error(`UPDATE_OPTION_IMAGE - 상품 ${registrationId} 에 옵션 ${optionNumber} 이 없습니다`);
        return;
      }
      const { product, optionIndex } = target;
      // updateOptionImageState 함수를 사용하여 옵션 업데이트 - 여기가 수정된 부분
      const updatedOption = updateOptionImageState(product.options[optionIndex], imageData);
      console.log('옵션 이미지 업데이트:', updatedOption);
      // Vue의 반응성을 위해 Vue.set 사용
      Vue.set(product.options, optionIndex, updatedOption);

      // 상품 상태도 업데이트
      if (product.mainImageStatus === 'pending') {
        product.mainImageStatus = 'partially_completed';
      } else if (product.options.every(opt =>
        opt.mainImageStatus && opt.mainImageStatus.status === 'completed')) {
        product.mainImageStatus = 'completed';
      }

      console.log('옵션 이미지 업데이트 완료:', optionNumber, updatedOption.mainImageStatus);

      // 선택된 옵션이 업데이트된 옵션이면 선택된 옵션도 업데이트
      if (state.selectedOption && state.selectedOption.optionNumber === optionNumber) {
        state.selectedOption = updatedOption;
      }
    },

    // 작업 상태 관련 mutations
    SET_PROCESSING(state, isProcessing) {
      state.processing = isProcessing;
    },

    SET_PROGRESS_MESSAGE(state, message) {
      state.progressMessage = message;
    },

    SET_WORKING_IMAGE_DATA(state, imageData) {
      state.workingImageData = imageData;
    },

    CLEAR_WORKING_IMAGE_DATA(state) {
      state.workingImageData = null;
    },

    // 작업 흐름 관련 mutations
    SET_CURRENT_TASK(state, task) {
      state.workflowStatus.currentTask = task;
    },

    ADD_COMPLETED_TASK(state, task) {
      if (!state.workflowStatus.completedTasks.includes(task)) {
        state.workflowStatus.completedTasks.push(task);
      }
    },

    SET_WORKFLOW_PROGRESS(state, progress) {
      state.workflowStatus.progress = Math.min(100, Math.max(0, progress));
    },

    // 작업 결과 업데이트 mutations
    UPDATE_MAIN_IMAGE_RESULT(state, { productId, optionNumber, result }) {
      const product = state.rocketProducts.find(p => p.registrationId === productId);
      if (!product || !product.options) return;

      const option = product.options.find(o => o.optionNumber === optionNumber);
      if (!option) return;

      // mainImageStatus 업데이트
      option.mainImageStatus = {
        ...option.mainImageStatus,
        status: 'completed',
        processedImage: result.processedUrl,
        textRemoved: result.textRemoved,
        dimensions: result.dimensions,
        filesize: result.filesize
      };

      // 상품 상태 업데이트 트리거
      this.commit('UPDATE_ROCKET_PRODUCT', product);
    },

    UPDATE_ADDITIONAL_IMAGE_RESULT(state, { productId, result }) {
      const product = state.rocketProducts.find(p => p.registrationId === productId);
      if (!product) return;

      product.additionalImages = result.images;
      product.additionalImageStatus = 'completed';

      this.commit('UPDATE_ROCKET_PRODUCT', product);
    },

    UPDATE_DETAIL_IMAGE_RESULT(state, { productId, result }) {
      const product = state.rocketProducts.find(p => p.registrationId === productId);
      if (!product) return;

      product.detailImages = result.images;
      product.detailHtmlContents = result.htmlContents;
      product.detailImageStatus = 'completed';

      this.commit('UPDATE_ROCKET_PRODUCT', product);
    },

    UPDATE_KOREAN_LABEL_RESULT(state, { productId, result }) {
      const product = state.rocketProducts.find(p => p.registrationId === productId);
      if (!product) return;

      product.koreanLabels = result.labels;
      product.koreanLabelStatus = 'completed';

      this.commit('UPDATE_ROCKET_PRODUCT', product);
    },

    UPDATE_PRICING_RESULT(state, { productId, result }) {
      const product = state.rocketProducts.find(p => p.registrationId === productId);
      if (!product) return;

      product.pricing = result;
      product.pricingStatus = 'completed';

      this.commit('UPDATE_ROCKET_PRODUCT', product);
    },

    UPDATE_SEO_RESULT(state, { productId, result }) {
      const product = state.rocketProducts.find(p => p.registrationId === productId);
      if (!product) return;

      product.seo = result;
      product.seoStatus = 'completed';

      this.commit('UPDATE_ROCKET_PRODUCT', product);
    },

    UPDATE_QUOTATION_RESULT(state, { productId, result }) {
      const product = state.rocketProducts.find(p => p.registrationId === productId);
      if (!product) return;

      product.quotation = result;
      product.quotationStatus = 'completed';

      this.commit('UPDATE_ROCKET_PRODUCT', product);
    },
    SET_WAITING_DETAIL_HTML(state, isWaiting) {
      state.waitingDetailHtml = isWaiting;
    },

    ADD_DETAIL_HTML_RESULT(state, { imageUrl, htmlContent }) {
      Vue.set(state.detailHtmlResults, imageUrl, htmlContent);
    },
    SET_KOREAN_LABEL_DATA(state, { productId, aiLabels, koreanLabelImage }) {
      const product = state.rocketProducts.find(p => p.registrationId === productId);
      if (product) {
        product.koreanLabels = { ...product.koreanLabels, ...aiLabels };
        product.koreanLabelImage = koreanLabelImage;
      }
    },
    UPDATE_SIZE_CHART_RESULT(state, { productId, result }) {
      const product = state.rocketProducts.find(p => p.registrationId === productId);
      if (!product) return;

      product.sizeChart = result.sizeChart;
      product.sizeChartImage = result.sizeChartImage;
      product.sizeChartStatus = 'completed';

      this.commit('UPDATE_ROCKET_PRODUCT', product);
    },
    // 기능별 상품 정보 업데이트 뮤테이션
    UPDATE_PRODUCT_FEATURE(state, { feature, productData }) {
      console.log(`===== Vuex: UPDATE_PRODUCT_FEATURE 뮤테이션 실행 (${feature}) =====`);

      // 상품 찾기
      const index = state.rocketProducts.findIndex(p => p.registrationId === productData.registrationId);
      if (index === -1) {
        console.warn('업데이트할 상품을 찾을 수 없음:', productData.registrationId);
        return;
      }

      console.log('Vuex: 업데이트 전 상품 정보 확인');
      if (state.rocketProducts[index].options && state.rocketProducts[index].options.length > 0) {
        const firstOption = state.rocketProducts[index].options[0];
        if (firstOption.coupangDoc && firstOption.coupangDoc.jsonDocument && firstOption.coupangDoc.jsonDocument[0]) {
          console.log('Vuex: 뮤테이션 전 첫번째 옵션 coupangDoc 상품명:',
            firstOption.coupangDoc.jsonDocument[0].startPage?.productName);
        }
      }

      // 🔍 [DEBUG] 깊은 복사 전 state.rocketProducts[index]의 exposedAttributes 순서 확인
      const stateBeforeAttrs = state.rocketProducts[index].coupangDoc?.jsonDocument?.[0]?.productPage?.commonAttributes?.exposedAttributes;
      if (stateBeforeAttrs && stateBeforeAttrs.length > 0) {
        console.log(`🔍 [UPDATE_PRODUCT_FEATURE] ${feature} - state에서 깊은 복사 전 exposedAttributes 순서:`,
          stateBeforeAttrs.map(a => a.attributeName).join(', '));
      }

      // 🔍 [DEBUG] productData의 exposedAttributes 순서 확인
      const productDataAttrs = productData.coupangDoc?.jsonDocument?.[0]?.productPage?.commonAttributes?.exposedAttributes;
      if (productDataAttrs && productDataAttrs.length > 0) {
        console.log(`🔍 [UPDATE_PRODUCT_FEATURE] ${feature} - productData(입력)의 exposedAttributes 순서:`,
          productDataAttrs.map(a => a.attributeName).join(', '));
      }

      // 현재 상품 가져오기 (깊은 복사)
      const product = JSON.parse(JSON.stringify(state.rocketProducts[index]));

      // 🔍 [DEBUG] 깊은 복사 후 product의 exposedAttributes 순서 확인
      const productAfterAttrs = product.coupangDoc?.jsonDocument?.[0]?.productPage?.commonAttributes?.exposedAttributes;
      if (productAfterAttrs && productAfterAttrs.length > 0) {
        console.log(`🔍 [UPDATE_PRODUCT_FEATURE] ${feature} - 깊은 복사 후 exposedAttributes 순서:`,
          productAfterAttrs.map(a => a.attributeName).join(', '));

        // 순서 변경 감지
        if (stateBeforeAttrs && stateBeforeAttrs.map(a => a.attributeName).join(',') !== productAfterAttrs.map(a => a.attributeName).join(',')) {
          console.error(`🚨 [UPDATE_PRODUCT_FEATURE] ${feature} - JSON.parse(JSON.stringify)에서 순서 변경 감지!`);
        }
      }

      // 상태 필드 이름 (feature + 'Status')
      const statusField = `${feature}Status`;

      // 상태 필드 업데이트 - 객체인 경우와 문자열인 경우를 구분하여 처리
      if (typeof product[statusField] === 'object') {
        // 객체인 경우 (mainImageStatus 등), status 속성 업데이트
        if (!product[statusField]) product[statusField] = {};
        product[statusField].status = productData[statusField]?.status || 'completed';
      } else {
        // 문자열인 경우 (seoStatus 등)
        product[statusField] = productData[statusField] || 'completed';
      }

      // 기능별 데이터 업데이트
      switch (feature) {
        case 'seo':
          console.log('SEO 데이터 업데이트 전:', {
            상태: product.seoStatus,
            데이터: product.seo ? Object.keys(product.seo) : null
          });

          product.seo = productData.seo;

          console.log('SEO 데이터 업데이트 후:', {
            상태: product.seoStatus,
            데이터: product.seo ? Object.keys(product.seo) : null
          });
          break;

        case 'pricing':
          console.log('가격 데이터 업데이트 전:', {
            상태: product.pricingStatus,
            데이터: product.pricing ? '데이터 있음' : '데이터 없음'
          });

          product.pricing = productData.pricing;

          console.log('가격 데이터 업데이트 후:', {
            상태: product.pricingStatus,
            데이터: product.pricing ? '데이터 있음' : '데이터 없음'
          });
          break;

        case 'mainImage':
          console.log('메인 이미지 데이터 업데이트 전:', {
            상태: product.mainImageStatus ? product.mainImageStatus.status : '없음',
            이미지: product.mainImageStatus ? (product.mainImageStatus.processedImage ? '있음' : '없음') : '없음'
          });

          product.mainImageStatus = productData.mainImageStatus;

          console.log('메인 이미지 데이터 업데이트 후:', {
            상태: product.mainImageStatus ? product.mainImageStatus.status : '없음',
            이미지: product.mainImageStatus ? (product.mainImageStatus.processedImage ? '있음' : '없음') : '없음'
          });
          break;

        case 'additionalImage':
          console.log('추가 이미지 데이터 업데이트 전:', {
            상태: product.additionalImageStatus,
            이미지: product.additionalImages ? product.additionalImages.length : 0
          });

          product.additionalImageStatus = productData.additionalImageStatus;
          product.additionalImages = productData.additionalImages;

          console.log('추가 이미지 데이터 업데이트 후:', {
            상태: product.additionalImageStatus,
            이미지: product.additionalImages ? product.additionalImages.length : 0
          });
          break;

        case 'detailImage':
          console.log('상세 이미지 데이터 업데이트 전:', {
            상태: product.detailImageStatus,
            이미지: product.detailImages ? product.detailImages.length : 0,
            HTML: product.detailHtml ? '있음' : '없음'
          });

          product.detailImageStatus = productData.detailImageStatus;
          product.detailImages = productData.detailImages;
          product.detailHtml = productData.detailHtml;

          console.log('상세 이미지 데이터 업데이트 후:', {
            상태: product.detailImageStatus,
            이미지: product.detailImages ? product.detailImages.length : 0,
            HTML: product.detailHtml ? '있음' : '없음'
          });
          break;

        case 'sizeChart':
          console.log('사이즈표 데이터 업데이트 전:', {
            상태: product.sizeChartStatus,
            데이터: product.sizeChart ? '데이터 있음' : '데이터 없음'
          });

          product.sizeChartStatus = productData.sizeChartStatus;
          product.sizeChart = productData.sizeChart;
          product.sizeChartImage = productData.sizeChartImage;

          console.log('사이즈표 데이터 업데이트 후:', {
            상태: product.sizeChartStatus,
            데이터: product.sizeChart ? '데이터 있음' : '데이터 없음'
          });
          break;

        case 'koreanLabel':
          console.log('UPDATE_PRODUCT_FEATURE - koreanLabel 기존 데이터:', {
            기존상태: product.koreanLabelStatus,
            기존라벨: product.koreanLabels,
            기존이미지: product.koreanLabelImage
          });

          product.koreanLabelStatus = productData.koreanLabelStatus;
          product.koreanLabels = productData.koreanLabels;
          product.koreanLabelImage = productData.koreanLabelImage;

          console.log('UPDATE_PRODUCT_FEATURE - koreanLabel 업데이트 후:', {
            상태: product.koreanLabelStatus,
            라벨: product.koreanLabels,
            이미지: product.koreanLabelImage
          });
          break;

        case 'quotation':
          console.log('견적서 데이터 업데이트 전:', {
            상태: product.quotationStatus,
            견적서: product.quotation ? '데이터 있음' : '데이터 없음'
          });

          product.quotationStatus = productData.quotationStatus;
          product.quotation = productData.quotation;

          console.log('견적서 데이터 업데이트 후:', {
            상태: product.quotationStatus,
            견적서: product.quotation ? '데이터 있음' : '데이터 없음'
          });
          break;
      }

      // 옵션 업데이트 (기능과 관련된 옵션 필드만)
      if (productData.options && productData.options.length > 0 && product.options) {
        productData.options.forEach(newOption => {
          const optionIndex = product.options.findIndex(o => o.optionNumber === newOption.optionNumber);
          if (optionIndex !== -1) {
            // 옵션 상태 필드 이름
            const optionStatusField = `${feature}Status`;

            // 상태 업데이트 - 객체와 문자열 구분
            if (typeof product.options[optionIndex][optionStatusField] === 'object') {
              // 객체인 경우 (mainImageStatus 등), status 속성 업데이트
              if (!product.options[optionIndex][optionStatusField]) {
                product.options[optionIndex][optionStatusField] = {};
              }

              if (newOption[optionStatusField]) {
                if (typeof newOption[optionStatusField] === 'object') {
                  product.options[optionIndex][optionStatusField].status =
                    newOption[optionStatusField].status || 'completed';
                } else {
                  product.options[optionIndex][optionStatusField].status =
                    newOption[optionStatusField] || 'completed';
                }
              } else {
                product.options[optionIndex][optionStatusField].status = 'completed';
              }
            } else {
              // 문자열인 경우 (seoStatus 등)
              product.options[optionIndex][optionStatusField] =
                newOption[optionStatusField] || 'completed';
            }

            // 기능별 필드 업데이트
            switch (feature) {
              case 'seo':
                if (newOption.korName) product.options[optionIndex].korName = newOption.korName;
                if (newOption.fullProductName) product.options[optionIndex].fullProductName = newOption.fullProductName;
                break;
              case 'pricing':
                if (newOption.supplyPrice !== undefined) product.options[optionIndex].supplyPrice = newOption.supplyPrice;
                if (newOption.sellingPrice !== undefined) product.options[optionIndex].sellingPrice = newOption.sellingPrice;
                // 원래의 purchasePrice 필드는 그대로 유지하되, 로그를 추가
                if (newOption.purchasePrice !== undefined) {
                  product.options[optionIndex].purchasePrice = newOption.purchasePrice;
                  console.log(`옵션 ${product.options[optionIndex].optionNumber} purchasePrice 업데이트: ${newOption.purchasePrice}`);
                }
                if (newOption.supplyMargin !== undefined) product.options[optionIndex].supplyMargin = newOption.supplyMargin;
                if (newOption.sellingMargin !== undefined) product.options[optionIndex].sellingMargin = newOption.sellingMargin;
                break;
              case 'mainImage':
                if (newOption.mainImageStatus) product.options[optionIndex].mainImageStatus = newOption.mainImageStatus;
                break;
              case 'koreanLabel':
                // 한글 표시사항 관련 옵션 필드 업데이트
                if (newOption.koreanLabelStatus) product.options[optionIndex].koreanLabelStatus = newOption.koreanLabelStatus;
                // 옵션별 한글 표시사항 필드가 있다면 업데이트
                if (newOption.koreanLabels) product.options[optionIndex].koreanLabels = newOption.koreanLabels;
                break;
              case 'additionalImage':
                // 추가 이미지 관련 옵션 필드 업데이트
                if (newOption.additionalImageStatus) product.options[optionIndex].additionalImageStatus = newOption.additionalImageStatus;
                break;
              case 'detailImage':
                // 상세 이미지 관련 옵션 필드 업데이트
                if (newOption.detailImageStatus) product.options[optionIndex].detailImageStatus = newOption.detailImageStatus;
                break;
              case 'quotation':
                // 견적서 관련 옵션 필드 업데이트
                if (newOption.quotationStatus) product.options[optionIndex].quotationStatus = newOption.quotationStatus;
                break;
            }

            // coupangDoc 관련 필드 업데이트 (기능별로)
            if (newOption.coupangDoc && product.options[optionIndex].coupangDoc) {
              // 실제 구현은 기능별 필드 정의 필요
              switch (feature) {
                case 'seo':
                  // SEO 관련 coupangDoc 필드 업데이트
                  if (product.options[optionIndex].coupangDoc.jsonDocument &&
                    product.options[optionIndex].coupangDoc.jsonDocument.length > 0) {
                    // 업데이트 전 값 로깅
                    const oldDocName = product.options[optionIndex].coupangDoc.productName;
                    const oldStartPageName = product.options[optionIndex].coupangDoc.jsonDocument[0].startPage?.productName;

                    console.log(`🔄 옵션 ${product.options[optionIndex].optionNumber}의 coupangDoc 상품명 업데이트:`);
                    console.log(`- 업데이트 전 coupangDoc.productName: ${oldDocName}`);
                    console.log(`- 업데이트 전 startPage.productName: ${oldStartPageName}`);
                    console.log(`- 업데이트할 새 상품명: ${newOption.fullProductName || '없음'}`);

                    // 새 상품명 확인
                    const newProductName = newOption.fullProductName || product.options[optionIndex].coupangDoc.productName;

                    // 상품명 업데이트
                    product.options[optionIndex].coupangDoc.productName = newProductName;

                    // startPage 상품명 업데이트
                    if (product.options[optionIndex].coupangDoc.jsonDocument[0].startPage) {
                      product.options[optionIndex].coupangDoc.jsonDocument[0].startPage.productName = newProductName;
                    }

                    // 모델명도 상품명과 동일하게 업데이트 (quotation 요구사항)
                    if (product.options[optionIndex].coupangDoc.jsonDocument[0].productPage) {
                      const oldModelNumber = product.options[optionIndex].coupangDoc.jsonDocument[0].productPage.modelNumber;
                      product.options[optionIndex].coupangDoc.jsonDocument[0].productPage.modelNumber = newProductName;
                      console.log(`- 모델명도 업데이트: "${oldModelNumber}" → "${newProductName}"`);
                    }

                    // 업데이트 후 값 로깅
                    console.log(`✅ 업데이트 완료:`);
                    console.log(`- 업데이트 후 coupangDoc.productName: ${product.options[optionIndex].coupangDoc.productName}`);
                    console.log(`- 업데이트 후 startPage.productName: ${product.options[optionIndex].coupangDoc.jsonDocument[0].startPage?.productName}`);
                    console.log(`- 업데이트 후 modelNumber: ${product.options[optionIndex].coupangDoc.jsonDocument[0].productPage?.modelNumber}`);

                    // 검색 태그 업데이트
                    if (product.options[optionIndex].coupangDoc.jsonDocument[0].productPage && product.seo && product.seo.keywords) {
                      const keywords = product.seo.keywords.join(', ');
                      console.log(`- 검색 태그 업데이트: ${keywords}`);
                      product.options[optionIndex].coupangDoc.jsonDocument[0].productPage.searchTags = keywords;
                    }
                  }
                  break;
                case 'pricing':
                  // 가격 관련 coupangDoc 필드 업데이트
                  if (product.options[optionIndex].coupangDoc.jsonDocument &&
                    product.options[optionIndex].coupangDoc.jsonDocument.length > 0 &&
                    product.options[optionIndex].coupangDoc.jsonDocument[0].productPage &&
                    product.options[optionIndex].coupangDoc.jsonDocument[0].productPage.commonAttributes) {

                    const commonAttributes = product.options[optionIndex].coupangDoc.jsonDocument[0].productPage.commonAttributes;

                    // 공급가, 판매가, MSRP 업데이트
                    console.log(`store mutation: 옵션 ${product.options[optionIndex].optionNumber} coupangDoc 가격 정보 업데이트:`);
                    console.log(`- 기존 purchasePrice: ${commonAttributes.purchasePrice}`);
                    console.log(`- 새 supplyPrice: ${newOption.supplyPrice}`);

                    if (newOption.supplyPrice !== undefined) {
                      commonAttributes.purchasePrice = Number(Math.round(newOption.supplyPrice));
                      console.log(`- purchasePrice를 supplyPrice로 설정: ${commonAttributes.purchasePrice}`);
                    }

                    if (newOption.sellingPrice !== undefined) {
                      commonAttributes.coupangSalePrice = Number(Math.round(newOption.sellingPrice));
                      console.log(`- coupangSalePrice 설정: ${commonAttributes.coupangSalePrice}`);
                    }

                    if (newOption.sellingPrice !== undefined) {
                      commonAttributes.msrp = Number(Math.floor(newOption.sellingPrice * 1.1));
                      console.log(`- msrp 설정: ${commonAttributes.msrp}`);
                    }
                  }
                  break;
                case 'mainImage':
                  // 대표 이미지 관련 coupangDoc 필드 업데이트
                  if (product.options[optionIndex].coupangDoc.jsonDocument &&
                    product.options[optionIndex].coupangDoc.jsonDocument.length > 0 &&
                    product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage &&
                    product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage.images) {

                    if (newOption.mainImageStatus && newOption.mainImageStatus.processedImage) {
                      product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage.images.mainImage =
                        newOption.mainImageStatus.processedImage;
                    }
                  }
                  break;
                case 'additionalImage':
                  // 추가 이미지 관련 coupangDoc 필드 업데이트
                  if (product.options[optionIndex].coupangDoc.jsonDocument &&
                    product.options[optionIndex].coupangDoc.jsonDocument.length > 0 &&
                    product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage &&
                    product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage.images) {

                    if (product.additionalImages && product.additionalImages.length > 0) {
                      const imageUrls = product.additionalImages.map(img => img.url).filter(Boolean);
                      product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage.images.additionalImage =
                        imageUrls.join(',');
                    }
                  }
                  break;
                case 'detailImage':
                  // 상세 이미지 관련 coupangDoc 필드 업데이트
                  if (product.options[optionIndex].coupangDoc.jsonDocument &&
                    product.options[optionIndex].coupangDoc.jsonDocument.length > 0 &&
                    product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage &&
                    product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage.details) {

                    const details = product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage.details;

                    // 상세 이미지 URL 설정
                    if (product.detailImages && product.detailImages.length > 0) {
                      details.detailedImage = product.detailImages[0];
                      details.htmlProductDetailContent = ""; // HTML 콘텐츠는 비움
                    }

                    // altText — 후보 순서·한자 거름은 detailAltText 한 곳(DetailImageEdit·server updateFeature 와 같은 순서 · PR261020-54B539)
                    details.altText = detailAltText(product, product.options[optionIndex].korName);
                  }
                  break;
                case 'koreanLabel':
                  // 한글 표시사항 관련 coupangDoc 필드 업데이트
                  if (product.options[optionIndex].coupangDoc.jsonDocument &&
                    product.options[optionIndex].coupangDoc.jsonDocument.length > 0 &&
                    product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage &&
                    product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage.images) {

                    console.log('한글 표시사항 coupangDoc 업데이트 - 옵션:', optionIndex, '이미지:', product.koreanLabelImage);

                    // labelImages 배열이 없으면 생성
                    if (!product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage.images.labelImages) {
                      product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage.images.labelImages = [];
                    }

                    // 한글 표시사항 라벨 이미지 업데이트
                    const labelImageIndex = product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage.images.labelImages.findIndex(
                      img => img.labelImageType === '제품 한글 표시사항 라벨 또는 도안 이미지'
                    );

                    if (product.koreanLabelImage) {
                      if (labelImageIndex !== -1) {
                        product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage.images.labelImages[labelImageIndex].labelImageFiles =
                          product.koreanLabelImage;

                        console.log('한글 표시사항 이미지 업데이트 완료:', product.koreanLabelImage);
                      } else {
                        // 없으면 새로 추가
                        const newLabelImage = {
                          labelImageType: '제품 한글 표시사항 라벨 또는 도안 이미지',
                          labelImageFiles: product.koreanLabelImage
                        };

                        product.options[optionIndex].coupangDoc.jsonDocument[0].imagePage.images.labelImages.push(newLabelImage);
                        console.log('한글 표시사항 이미지 새로 추가:', newLabelImage);
                      }
                    } else {
                      console.warn('한글 표시사항 이미지가 없습니다. product.koreanLabelImage:', product.koreanLabelImage);
                    }
                  } else {
                    console.warn('coupangDoc 구조에 imagePage 또는 images가 없습니다.');
                  }
                  break;
                // 'quotation' 갈래는 없앴다 — 옛 updateCoupangDoc(@deprecated)에 문서 한 칸을 넘겨 늘 false 로 빠졌고,
                //   돌았다면 노출속성을 통째 바꿔 사람이 고친 값을 덮었다(saram 판 #737 ④ · cpl-505a-optcolorrevert-1)
              }
            }
          }
        });
      }

      // 🔍 [DEBUG] Vue.set 전 product의 exposedAttributes 순서 확인
      const beforeVueSetAttrs = product.coupangDoc?.jsonDocument?.[0]?.productPage?.commonAttributes?.exposedAttributes;
      if (beforeVueSetAttrs && beforeVueSetAttrs.length > 0) {
        console.log(`🔍 [UPDATE_PRODUCT_FEATURE] ${feature} - Vue.set 전 exposedAttributes 순서:`,
          beforeVueSetAttrs.map(a => a.attributeName).join(', '));
      }

      // 전체 상품 업데이트
      Vue.set(state.rocketProducts, index, product);

      // 🔍 [DEBUG] Vue.set 후 state.rocketProducts[index]의 exposedAttributes 순서 확인
      const afterVueSetAttrs = state.rocketProducts[index].coupangDoc?.jsonDocument?.[0]?.productPage?.commonAttributes?.exposedAttributes;
      if (afterVueSetAttrs && afterVueSetAttrs.length > 0) {
        console.log(`🔍 [UPDATE_PRODUCT_FEATURE] ${feature} - Vue.set 후 exposedAttributes 순서:`,
          afterVueSetAttrs.map(a => a.attributeName).join(', '));

        // 순서 변경 감지
        if (beforeVueSetAttrs && beforeVueSetAttrs.map(a => a.attributeName).join(',') !== afterVueSetAttrs.map(a => a.attributeName).join(',')) {
          console.error(`🚨 [UPDATE_PRODUCT_FEATURE] ${feature} - Vue.set에서 순서 변경 감지!`);
        }
      }

      // 선택된 상품이 업데이트된 상품이면 선택된 상품도 업데이트
      if (state.selectedRocketProduct && state.selectedRocketProduct.registrationId === product.registrationId) {
        state.selectedRocketProduct = product;
      }

      console.log(`[UPDATE_PRODUCT_FEATURE] ${feature} 업데이트 완료`);
    },
    // 저장 요청 중 서버에 반영되지 못한 옵션이 있었음을 기록한다
    SET_FEATURE_SAVE_WARNING(state, warning) {
      state.featureSaveWarning = warning;
    },
    SET_SEO_WORD_WARNING(state, warning) {
      state.seoWordWarning = warning;
    }
  },
  actions: {
    // 개별마진 근거값이 들어올 때까지 기다린다(#112). 받은 적이 없으면 지금 받는다.
    waitGrowthCostBasis() {
      if (growthCostBasisPromise) return growthCostBasisPromise;
      return loadGrowthCostBasis(this);
    },
    // 로그인/권한 정보를 로드한다. 여러 번 호출해도 실제 요청은 1회만 나간다.
    // 반환값: 로그인 여부(boolean)
    ensureAuth({ commit, state }) {
      if (state.user._id) {
        return Promise.resolve(true);
      }
      if (!loginStatusPromise) {
        loginStatusPromise = axios.post('/api/loginstatus')
          .then(result => {
            if (result.data.loginstatus == 'Login success') {
              commit('userupdate', result.data.userinfo);
              commit('dbupdate', result.data.dbs);
              localStorage.setItem('wasLoggedIn', 'true');
              return true;
            }
            commit('userupdate', state.userinit);
            return false;
          })
          .catch(e => {
            console.error('로그인 상태 확인 실패:', e);
            return false;
          });
      }
      return loginStatusPromise;
    },

    async updateProductSizeChart({ dispatch }, product) {
      if (!product || !product.registrationId) {
        throw new Error('올바른 상품 정보가 없습니다.');
      }

      return dispatch('updateProductFeature', {
        feature: 'sizeChart',
        productData: product
      });
    },

    async processSizeChart({ dispatch, commit }, product) {
      try {
        dispatch('setProcessing', {
          isProcessing: true,
          message: '사이즈표 처리 중...'
        });

        const result = await sizeChartService.process(product);

        if (result) {
          commit('UPDATE_SIZE_CHART_RESULT', {
            productId: product.registrationId,
            result
          });
        }

        dispatch('setProcessing', { isProcessing: false });
        return result;
      } catch (error) {
        console.error('사이즈표 처리 중 오류:', error);
        dispatch('setProcessing', { isProcessing: false });
        return null;
      }
    },
    // 기능별 상태만 업데이트하는 액션 추가
    async updateFeatureStatus({ dispatch }, { product, feature, status }) {
      try {
        // 🔍 [DEBUG] 깊은 복사 전 exposedAttributes 순서 확인
        const beforeAttrs = product.coupangDoc?.jsonDocument?.[0]?.productPage?.commonAttributes?.exposedAttributes;
        if (beforeAttrs && beforeAttrs.length > 0) {
          console.log(`🔍 [updateFeatureStatus] ${feature} - 깊은 복사 전 exposedAttributes 순서:`,
            beforeAttrs.map(a => a.attributeName).join(', '));
        }

        // 깊은 복사로 제품 복사
        const updatedProduct = JSON.parse(JSON.stringify(product));

        // 🔍 [DEBUG] 깊은 복사 후 exposedAttributes 순서 확인
        const afterAttrs = updatedProduct.coupangDoc?.jsonDocument?.[0]?.productPage?.commonAttributes?.exposedAttributes;
        if (afterAttrs && afterAttrs.length > 0) {
          console.log(`🔍 [updateFeatureStatus] ${feature} - 깊은 복사 후 exposedAttributes 순서:`,
            afterAttrs.map(a => a.attributeName).join(', '));

          // 순서 변경 감지
          if (beforeAttrs && beforeAttrs.map(a => a.attributeName).join(',') !== afterAttrs.map(a => a.attributeName).join(',')) {
            console.error(`🚨 [updateFeatureStatus] ${feature} - JSON.parse(JSON.stringify)에서 순서 변경 감지!`);
          }
        }

        // 상태 필드 이름 결정
        const statusField = `${feature}Status`;

        // 상품 상태 업데이트
        if (typeof updatedProduct[statusField] === 'object') {
          updatedProduct[statusField].status = status;
        } else {
          updatedProduct[statusField] = status;
        }

        // 옵션 상태 업데이트
        if (updatedProduct.options && updatedProduct.options.length > 0) {
          updatedProduct.options.forEach(option => {
            if (option[statusField] && typeof option[statusField] === 'object') {
              option[statusField].status = status;
            } else {
              option[statusField] = status;
            }
          });
        }

        console.log('상태 업데이트 완료:', updatedProduct);

        // 기능별 업데이트 액션 호출
        return await dispatch('updateProductFeature', {
          feature,
          productData: updatedProduct
        });
      } catch (error) {
        console.error(`상태 업데이트 중 오류 (${feature}, ${status}):`, error);
      }
    },
    // 기능별 상품 업데이트 액션들
    async updateProductFeature({ commit }, { feature, productData }) {
      // 목록용 문서로 기능 저장을 부르면 빠진 칸이 서버에 덮인다 — 보내기 전에 막는다
      assertNotLight(productData);
      try {
        console.log(`${feature} 정보 업데이트 시작`);
        console.log(productData)

        if (feature === 'koreanLabel') {
          console.log('koreanLabel 업데이트 시작 - 데이터:', {
            koreanLabels: productData.koreanLabels,
            koreanLabelImage: productData.koreanLabelImage,
            koreanLabelStatus: productData.koreanLabelStatus
          });

          // 서버 요청 직전에도 로깅
          console.log('koreanLabel 서버 요청 데이터:', {
            feature,
            koreanLabels: productData.koreanLabels,
            koreanLabelImage: productData.koreanLabelImage
          });
        }
        // 1. Vuex 상태 먼저 업데이트 (UI 반응성)
        commit('UPDATE_PRODUCT_FEATURE', { feature, productData });
        // console.log('commit 후의 productData:', productData);

        // 2. 서버에 기능별 업데이트 요청
        const response = await axios.post('/api/rocketReg/updateFeature', {
          feature,
          product: productData
        });
        // console.log('서버 응답:', response.data);

        // 응답 검증
        if (response.data.res !== 'success') {
          console.error(`${feature} 서버 저장 실패:`, response.data.alert || '업데이트 실패');
          throw new Error(response.data.alert || `${feature} 업데이트 실패`);
        }

        // 3. 서버가 짝을 못 찾은 옵션을 알려준 경우(응답의 notFound)
        // 실패로 던지지 않는다 — 이 액션은 모든 작업이 매번 부르므로 여기서 throw 하면
        // 정상 동작하던 작업 흐름까지 통째로 끊긴다. 서버와 같은 기조로 「저장은 그대로 두되
        // 관측 가능하게」 만 한다. 대신 조용히 넘기지 않도록 콘솔과 화면 양쪽에 남긴다.
        const notFound = response.data.notFound;
        if (Array.isArray(notFound) && notFound.length > 0) {
          console.error(`${feature} 저장 - 서버에서 짝을 찾지 못한 옵션 ${notFound.length}건 (registrationId: ${productData.registrationId}):`, notFound);
          commit('SET_FEATURE_SAVE_WARNING', {
            feature,
            registrationId: productData.registrationId,
            count: notFound.length
          });
        }

        // 4. 서버에서 반환된 데이터가 있으면 상태 확인
        if (response.data.updatedProduct) {
          console.log(`${feature} 서버 응답으로 확인 완료`);
        }

        return true;
      } catch (error) {
        console.error(`${feature} 업데이트 중 오류:`, error);
        throw error;
      }
    },

    // SEO 정보 업데이트 전용 액션
    async updateProductSeo({ dispatch, state }, product) {
      console.log('===== Vuex: updateProductSeo 액션 실행 =====');
      console.log('실행 시간:', new Date().toISOString());

      if (!product || !product.registrationId || !product.seo) {
        throw new Error('올바른 SEO 정보가 없습니다.');
      }

      console.log('Vuex: 업데이트할 SEO 정보:', product.seo.productName);

      // 업데이트 전 상태 상세 로깅
      console.log('▶️ 업데이트 전 상태 확인');
      if (product.options && product.options.length > 0) {
        const firstOption = product.options[0];
        console.log('- 첫번째 옵션 번호:', firstOption.optionNumber);
        console.log('- 옵션 coupangDoc 존재 여부:', !!firstOption.coupangDoc);

        if (firstOption.coupangDoc && firstOption.coupangDoc.jsonDocument && firstOption.coupangDoc.jsonDocument[0]) {
          console.log('- 옵션 coupangDoc.docId:', firstOption.coupangDoc.docId);
          console.log('- 옵션 coupangDoc 상품명:', firstOption.coupangDoc.jsonDocument[0].startPage?.productName);
          console.log('- coupangDoc 참조 객체 ID:', firstOption.coupangDoc.jsonDocument[0].toString().substring(0, 30));
        }
      }

      // productFeature 액션 재사용
      console.log('▶️ updateProductFeature 액션 호출...');
      const result = await dispatch('updateProductFeature', {
        feature: 'seo',
        productData: product
      });

      // 업데이트 후 상태 상세 확인
      console.log('▶️ 업데이트 후 상태 확인');
      if (state.selectedRocketProduct && state.selectedRocketProduct.options) {
        const firstOption = state.selectedRocketProduct.options[0];
        console.log('- 첫번째 옵션 번호:', firstOption?.optionNumber);
        console.log('- 옵션 coupangDoc 존재 여부:', !!firstOption?.coupangDoc);

        if (firstOption && firstOption.coupangDoc && firstOption.coupangDoc.jsonDocument) {
          console.log('- 옵션 coupangDoc.docId:', firstOption.coupangDoc.docId);
          console.log('- 옵션 coupangDoc 상품명:', firstOption.coupangDoc.jsonDocument[0].startPage?.productName);
          console.log('- coupangDoc 참조 객체 ID:', firstOption.coupangDoc.jsonDocument[0].toString().substring(0, 30));

          // 상품명 확인 및 비교
          const updatedName = firstOption.coupangDoc.jsonDocument[0].startPage?.productName;
          const seoName = state.selectedRocketProduct.seo?.productName;
          if (updatedName !== seoName) {
            console.log('⚠️ 주의: 업데이트 후 coupangDoc 상품명과 SEO 상품명이 일치하지 않음!');
            console.log('- coupangDoc 상품명:', updatedName);
            console.log('- SEO 상품명:', seoName);
          } else {
            console.log('✅ 업데이트 후 coupangDoc 상품명과 SEO 상품명 일치함');
          }
        }
      }

      console.log('===== Vuex: updateProductSeo 액션 완료 =====');
      return result;
    },

    // 가격 정보 업데이트 전용 액션
    async updateProductPricing({ dispatch }, product) {
      if (!product || !product.registrationId || !product.pricing) {
        throw new Error('올바른 가격 정보가 없습니다.');
      }

      return dispatch('updateProductFeature', {
        feature: 'pricing',
        productData: product
      });
    },

    // 대표 이미지 업데이트 전용 액션
    async updateProductMainImage({ dispatch }, product) {
      if (!product || !product.registrationId) {
        throw new Error('올바른 상품 정보가 없습니다.');
      }

      return dispatch('updateProductFeature', {
        feature: 'mainImage',
        productData: product
      });
    },

    // 추가 이미지 업데이트 전용 액션
    async updateProductAdditionalImage({ dispatch }, product) {
      if (!product || !product.registrationId || !product.additionalImages) {
        throw new Error('올바른 추가 이미지 정보가 없습니다.');
      }

      return dispatch('updateProductFeature', {
        feature: 'additionalImage',
        productData: product
      });
    },

    // 상세 이미지 업데이트 전용 액션
    async updateProductDetailImage({ dispatch }, product) {
      if (!product || !product.registrationId || !product.detailImages) {
        throw new Error('올바른 상세 이미지 정보가 없습니다.');
      }

      return dispatch('updateProductFeature', {
        feature: 'detailImage',
        productData: product
      });
    },

    // 한글 표시사항 업데이트 전용 액션
    async updateProductKoreanLabel({ dispatch }, product) {
      if (!product || !product.registrationId || !product.koreanLabels) {
        throw new Error('올바른 한글 표시사항 정보가 없습니다.');
      }

      return dispatch('updateProductFeature', {
        feature: 'koreanLabel',
        productData: product
      });
    },

    // 견적서 업데이트 전용 액션
    async updateProductQuotation({ dispatch }, product) {
      if (!product || !product.registrationId || !product.quotation) {
        throw new Error('올바른 견적서 정보가 없습니다.');
      }
      console.log('updateProductQuotation 액션 실행:', product);
      return dispatch('updateProductFeature', {
        feature: 'quotation',
        productData: product
      });
    },
    layoutModeAction(context, payload) {
      context.commit('layoutModeCommit', payload.dark)
    },
    // 로켓배송 상품 검색
    async searchRocketProducts({ commit }, searchParams) {
      try {
        commit('SET_PROCESSING', true);
        commit('SET_PROGRESS_MESSAGE', '상품 목록을 가져오는 중...');

        // 서버는 한 번에 한 쪽(최대 100건)만 준다 — 전량 응답이 서버 메모리를 터뜨렸다(2026-10-15).
        // hasMore 가 false 가 될 때까지 이어 받아 예전처럼 기간 안 전체를 채운다.
        // view:'list' = 목록 칸만(무거운 칸은 작업 직전에 ensureFullRocketProducts 로 받는다) · 쪽당 최대 500
        const PAGE_SIZE = 500;
        const collected = [];
        const seen = new Set();
        let offset = 0;
        let data = {};
        let hiddenTotal = 0;
        for (;;) {
          const page = await axios.post('/api/aiRocketReg/getlist', { ...searchParams, view: 'list', limit: PAGE_SIZE, offset });

          // 서버가 명시적으로 거절한 경우. products 만 보면 "빈 목록"으로 보여 아무 말도 안 나온다.
          data = page.data || {};
          if (data['요청결과'] === 'fail' || data.error) {
            const message = data.error || '상품 목록을 불러올 수 없습니다.';
            console.error('로켓배송 상품 검색 거절:', message);
            const rejection = new Error(message);
            rejection.serverRejected = true;   // 아래 catch 가 삼키지 않고 그대로 올려보내도록
            throw rejection;
          }
          if (!Array.isArray(data.products)) break;
          // 받는 사이 새 상품이 생기면 쪽이 밀려 같은 문서가 두 번 올 수 있다 — _id 로 한 번만
          let added = 0;
          data.products.forEach(p => {
            const key = String(p && p._id);
            if (!seen.has(key)) { seen.add(key); collected.push(p); added++; }
          });
          if (!data.hasMore || data.products.length === 0) break;
          // offset 을 모르는 옛 서버는 같은 쪽을 또 준다 — 더 받지 말고 "다 못 받음"으로 알린다
          if (added === 0) { hiddenTotal = data.total || 0; break; }
          offset += data.products.length;
          commit('SET_PROGRESS_MESSAGE', `상품 목록을 가져오는 중... (${collected.length}/${data.total})`);
        }
        const response = { data: Array.isArray(data.products) ? { ...data, products: collected } : data };
        commit('SET_ROCKET_PRODUCTS_HIDDEN_TOTAL', hiddenTotal);

        commit('SET_PROCESSING', false);
        commit('SET_PROGRESS_MESSAGE', '');

        if (response.data && response.data.products) {
          // 상품 데이터 안전성 검사
          if (!Array.isArray(response.data.products)) {
            console.error('❌ searchRocketProducts: response.data.products가 배열이 아닙니다:', typeof response.data.products);
            commit('SET_ROCKET_PRODUCTS', []);
            return [];
          }

          // 상세이미지 원본 칸은 완전 문서에만 만든다(목록용은 ensureFullRocketProducts 가 받을 때 만든다)
          const processedProducts = response.data.products.map(product => (product && product._light) ? product : addOriginDetailImages(product));

          console.log(`🔍 searchRocketProducts: ${processedProducts.length}개 상품 검색 완료`);
          commit('SET_ROCKET_PRODUCTS', processedProducts);
          return processedProducts;
        }

        console.log('🔍 searchRocketProducts: 검색 결과 없음');
        commit('SET_ROCKET_PRODUCTS', []);
        return [];
      } catch (error) {
        commit('SET_PROCESSING', false);
        commit('SET_PROGRESS_MESSAGE', '');
        console.error('로켓배송 상품 검색 중 오류:', error);

        // 오류 발생 시에도 빈 배열로 안전하게 설정
        commit('SET_ROCKET_PRODUCTS', []);

        // 서버가 사유를 말해준 거절은 화면이 그 사유를 보여줘야 한다. 빈 목록으로 덮지 않는다.
        if (error && error.serverRejected) throw error;
        return [];
      }
    },

    async requestKoreanLabelData({ commit }, { product }) {
      try {
        // AI 요청 — workflowService 에는 requestExtension 이 없다(없는 함수 호출 → TypeError 로 '요청 중' 멈춤).
        // koreanLabelService.requestExtension 이 requestExtensionWithPromise(45초 타임아웃·재시도)로 보낸다.
        await koreanLabelService.requestExtension({
          type: 'KOREAN_LABELS',
          productId: product.registrationId,
          prompt: koreanLabelService.promptForKoreanLabels(product) // koreanLabelService에서 프롬프트 생성
        });

        // 초기 라벨 정보 설정
        const initialLabels = {
          productName: product.productName,
          manufacturer: product.manufacturer || '제조사 정보 없음',
          origin: '중국',
          madein: '중국',
          caution: '용도 외에 사용금지. 파손및화기주의',
          standard: '14세이상',
        };
        // store에 commit
        commit('SET_KOREAN_LABEL_DATA', { productId: product.registrationId, labels: initialLabels });

      } catch (error) {
        console.error('AI 요청 중 오류:', error);
        throw error; // 삼키면 화면·작업 흐름이 성공으로 착각한다
      }
    },

    async updateRocketProduct({ commit, state }, product) {
      assertNotLight(product); // 목록용 문서는 저장 금지 — 빠진 칸이 지워진다
      try {
        console.log('🔄 updateRocketProduct 호출됨, 상품ID:', product.registrationId);

        // 상품 등록 상태 로깅
        console.log(`💾 상품 ${product.registrationId} 등록 상태:`, {
          registered: product.registered,
          verified: product.verified,
          // registrationStatus 는 여기서 뺐다 — 최상위에 없는 필드라 늘 undefined 로 찍혔고,
          // 그 로그를 보고 "그런 필드가 있다"고 믿은 코드가 일곱 자리 있었다. 옵션 쪽(아래)만 실재한다.
          hasCoupangDoc: !!product.coupangDoc,
          docId: product.coupangDoc?.docId || 'none'
        });

        // 옵션 상태 로깅
        if (product.options && product.options.length > 0) {
          console.log(`💾 저장할 상품의 ${product.options.length}개 옵션:`,
            product.options.map((opt, idx) => ({
              index: idx,
              optionNumber: opt.optionNumber,
              registered: opt.registered,
              verified: opt.verified,
              registrationStatus: opt.registrationStatus,
              hasCoupangDoc: !!opt.coupangDoc,
              docId: opt.coupangDoc?.docId || 'none'
            }))
          );

          // 옵션 등록 상태 통계
          const registeredCount = product.options.filter(opt => opt.registrationStatus === 'registered').length;
          const verifiedCount = product.options.filter(opt => opt.verified === true).length;
          const docIdCount = product.options.filter(opt => opt.coupangDoc && opt.coupangDoc.docId).length;

          console.log(`💾 옵션 등록 상태 통계:`, {
            totalOptions: product.options.length,
            registeredOptions: registeredCount,
            verifiedOptions: verifiedCount,
            optionsWithDocId: docIdCount,
            allOptionsRegistered: registeredCount === product.options.length,
            allOptionsVerified: verifiedCount === product.options.length,
            allOptionsHaveDocId: docIdCount === product.options.length
          });
        }

        // skipCoupangUpdate 파라미터 확인 (명시적으로 추출)
        const shouldSkipCoupangUpdate = product.skipCoupangUpdate === true;

        // skipCoupangUpdate 속성 제거 (서버로 전달하지 않기 위함)
        const productToSave = { ...product };
        delete productToSave.skipCoupangUpdate;

        // coupangDoc 동기화 확인 및 업데이트 (신규 추가)
        if (productToSave.options && productToSave.options.length > 0 &&
            state.selectedRocketProduct && state.selectedRocketProduct.registrationId === product.registrationId) {

          console.log('🔍 업데이트 전 coupangDoc 동기화 점검 시작');

          // 옵션 coupangDoc 복원 및 업데이트
          productToSave.options.forEach((option) => {
            // 기존 상태에서 매칭되는 옵션 찾기
            const existingOption = state.selectedRocketProduct.options?.find(o => o.optionNumber === option.optionNumber);

            // coupangDoc이 없는데 기존 상태에 있으면 복원 (목록용 옵션은 건너뜀)
            if (!option.coupangDoc && existingOption?.coupangDoc && !existingOption._light) {
              console.log(`옵션 ${option.optionNumber}: coupangDoc 없음 -> 기존 상태에서 복원`);
              option.coupangDoc = JSON.parse(JSON.stringify(existingOption.coupangDoc));
            }

            // coupangDoc 업데이트 (있는 경우에만)
            if (option.coupangDoc?.jsonDocument?.[0]) {
              const docObj = option.coupangDoc.jsonDocument[0];

              // SEO 데이터 및 상품명 업데이트
              if (productToSave.seo && docObj.startPage) {
                const fullProductName = option.korName ?
                  `${productToSave.seo.productName}, ${bundleOptionService.hubOptionName(productToSave.seo.productName, option.korName, productToSave)}` :
                  productToSave.seo.productName;

                if (docObj.startPage.productName !== fullProductName) {
                  console.log(`옵션 ${option.optionNumber}: coupangDoc 상품명 업데이트`);
                  console.log(`  - 이전: ${docObj.startPage.productName}`);
                  console.log(`  - 이후: ${fullProductName}`);

                  docObj.startPage.productName = fullProductName;
                  if (docObj.productPage) {
                    docObj.productPage.modelNumber = fullProductName;
                  }
                }

                // 검색 태그 업데이트
                if (docObj.productPage && productToSave.seo.keywords && productToSave.seo.keywords.length > 0) {
                  const searchTags = productToSave.seo.keywords.join(', ');
                  if (docObj.productPage.searchTags !== searchTags) {
                    console.log(`옵션 ${option.optionNumber}: coupangDoc 검색 태그 업데이트`);
                    docObj.productPage.searchTags = searchTags;
                  }
                }
              }

              // 가격 정보 업데이트
              if (docObj.productPage?.commonAttributes) {
                if (option.supplyPrice !== undefined) {
                  docObj.productPage.commonAttributes.purchasePrice = Number(Math.round(option.supplyPrice));
                }
                if (option.sellingPrice !== undefined) {
                  docObj.productPage.commonAttributes.coupangSalePrice = Number(Math.round(option.sellingPrice));
                  docObj.productPage.commonAttributes.msrp = Number(Math.floor(option.sellingPrice * 1.1));
                }
              }
            }
          });

          console.log('🔍 coupangDoc 동기화 점검 완료');
        }

        // 1. 우선 Vuex 상태 업데이트 (UI 즉시 반응)
        commit('UPDATE_ROCKET_PRODUCT', productToSave);
        console.log('✅ Vuex 상태 업데이트 완료');

        // 2. 서버에 저장
        console.log('💾 서버에 상품 저장 시작...');

        // 서버에 전송하기 직전 상태 로깅
        console.log('💾 서버에 전송하기 직전 상품 상태:', productToSave);

        const response = await axios.post('/api/rocketReg/saveItems', [productToSave]);
        console.log('💾 서버 응답:', response.data);

        // 응답 확인 및 오류 처리
        if (response.data.res !== 'success') {
          console.error('❌ 서버 저장 실패:', response.data.message || '상품 정보 업데이트 실패');
          throw new Error(response.data.message || '상품 정보 업데이트 실패');
        }

        // 3. 서버에서 반환된 저장 데이터가 있으면 상태 재업데이트
        if (response.data.savedItems && response.data.savedItems.length > 0) {
          const savedProduct = response.data.savedItems[0];

          // 서버 응답의 savedItems 로깅
          console.log(`💾 서버 응답의 savedItems[0] 데이터:`, {
            productId: savedProduct.registrationId,
            registered: savedProduct.registered,
            verified: savedProduct.verified,
            hasOptions: savedProduct.options && savedProduct.options.length > 0,
            optionsCount: savedProduct.options ? savedProduct.options.length : 0,
            registeredOptionsCount: savedProduct.options ?
              savedProduct.options.filter(opt => opt.registrationStatus === 'registered').length : 0,
            optionsWithDocId: savedProduct.options ?
              savedProduct.options.filter(opt => opt.coupangDoc && opt.coupangDoc.docId).length : 0
          });

          // 서버 응답과 원본 데이터 비교
          console.log(`💾 서버 응답과 원본 데이터 비교:`, {
            'registered (원본)': productToSave.registered,
            'registered (서버)': savedProduct.registered,
            'verified (원본)': productToSave.verified,
            'verified (서버)': savedProduct.verified,
            'optionsCount (원본)': productToSave.options ? productToSave.options.length : 0,
            'optionsCount (서버)': savedProduct.options ? savedProduct.options.length : 0,
            'registeredOptionsCount (원본)': productToSave.options ?
              productToSave.options.filter(opt => opt.registrationStatus === 'registered').length : 0,
            'registeredOptionsCount (서버)': savedProduct.options ?
              savedProduct.options.filter(opt => opt.registrationStatus === 'registered').length : 0,
            'optionsWithDocId (원본)': productToSave.options ?
              productToSave.options.filter(opt => opt.coupangDoc && opt.coupangDoc.docId).length : 0,
            'optionsWithDocId (서버)': savedProduct.options ?
              savedProduct.options.filter(opt => opt.coupangDoc && opt.coupangDoc.docId).length : 0
          });

          // 중요: 등록 상태 플래그 유지 확인
          if (productToSave.registered === true && !savedProduct.registered) {
            console.log('⚠️ 서버 응답에서 registered 플래그 유실 -> 복원');
            savedProduct.registered = true;
          }

          if (productToSave.verified === true && !savedProduct.verified) {
            console.log('⚠️ 서버 응답에서 verified 플래그 유실 -> 복원');
            savedProduct.verified = true;
          }

          // 서버 응답에서 coupangDoc 유실 확인 및 복원 처리
          if (savedProduct.options && productToSave.options) {
            let dataRestored = false;

            savedProduct.options.forEach((savedOption) => {
              const sourceOption = productToSave.options.find(o => o.optionNumber === savedOption.optionNumber);

              // 옵션 데이터 비교 로깅
              if (sourceOption) {
                console.log(`💾 옵션 ${savedOption.optionNumber} 데이터 비교:`, {
                  'registered (원본)': sourceOption.registered,
                  'registered (서버)': savedOption.registered,
                  'verified (원본)': sourceOption.verified,
                  'verified (서버)': savedOption.verified,
                  'registrationStatus (원본)': sourceOption.registrationStatus,
                  'registrationStatus (서버)': savedOption.registrationStatus,
                  'hasCoupangDoc (원본)': !!sourceOption.coupangDoc,
                  'hasCoupangDoc (서버)': !!savedOption.coupangDoc,
                  'docId (원본)': sourceOption.coupangDoc?.docId || 'none',
                  'docId (서버)': savedOption.coupangDoc?.docId || 'none'
                });
              }

              // coupangDoc 유실 확인
              if (sourceOption?.coupangDoc && !savedOption.coupangDoc) {
                console.log(`⚠️ 옵션 ${savedOption.optionNumber}: 서버 응답에서 coupangDoc 유실됨 -> 복원`);
                savedOption.coupangDoc = JSON.parse(JSON.stringify(sourceOption.coupangDoc));
                dataRestored = true;
              }

              // registrationStatus 유실 확인
              if (sourceOption?.registrationStatus === 'registered' && savedOption.registrationStatus !== 'registered') {
                console.log(`⚠️ 옵션 ${savedOption.optionNumber}: 서버 응답에서 registrationStatus 유실됨 -> 'registered'로 복원`);
                savedOption.registrationStatus = 'registered';
                dataRestored = true;
              }

              // verified 플래그 유실 확인
              if (sourceOption?.verified === true && savedOption.verified !== true) {
                console.log(`⚠️ 옵션 ${savedOption.optionNumber}: 서버 응답에서 verified 플래그 유실됨 -> 복원`);
                savedOption.verified = true;
                dataRestored = true;
              }

              // registered 플래그 유실 확인
              if (sourceOption?.registered === true && savedOption.registered !== true) {
                console.log(`⚠️ 옵션 ${savedOption.optionNumber}: 서버 응답에서 registered 플래그 유실됨 -> 복원`);
                savedOption.registered = true;
                dataRestored = true;
              }
            });

            // 상태 업데이트
            if (dataRestored) {
              console.log('✅ 서버 응답에서 유실된 데이터 복원 후 상태 업데이트');
            } else {
              console.log('✅ 서버 응답으로 상태 업데이트 완료 (유실 데이터 없음)');
            }

            // 상태 업데이트 - 중요: 어떤 경우든 서버에서 반환된 데이터로 업데이트
            console.log(`💾 복원 후 상품 ${savedProduct.registrationId} 등록 상태:`, savedProduct);

            commit('UPDATE_ROCKET_PRODUCT', savedProduct);
          } else {
            console.log('✅ 서버 응답으로 상태 업데이트 완료');
            commit('UPDATE_ROCKET_PRODUCT', savedProduct);
          }
        } else {
          console.log('⚠️ 서버 응답에 savedItems가 비어있습니다. 원래의 상태 유지');

          // 상태 유지를 위해 로그만 추가 - coupangDoc 정보 확인
          if (productToSave.options && productToSave.options.length > 0) {
            productToSave.options.forEach(option => {
              if (option.coupangDoc && option.coupangDoc.jsonDocument && option.coupangDoc.jsonDocument.length > 0) {
                const docObj = option.coupangDoc.jsonDocument[0];
                if (docObj.productPage && docObj.productPage.commonAttributes) {
                  console.log(`상품 저장 후 옵션 ${option.optionNumber} coupangDoc 값:`, {
                    purchasePrice: docObj.productPage.commonAttributes.purchasePrice,
                    supplyPrice: option.supplyPrice,
                    coupangSalePrice: docObj.productPage.commonAttributes.coupangSalePrice,
                  });
                }
              }
            });
          }
        }

        // 4. coupangDoc 업데이트는 스킵 (regRocketApi에서 처리)
        if (shouldSkipCoupangUpdate) {
          console.log('쿠팡 문서 업데이트 스킵');
        }

        return true;
      } catch (error) {
        console.error('상품 정보 업데이트 중 오류:', error);
        throw error;
      }
    },
    async updateCoupangDocument(context, payload) {
      try {
        console.log('===== updateCoupangDocument 시작 =====');

        // payload에서 product와 option 확인
        if (!payload) {
          console.error('payload가 제공되지 않았습니다.');
          return false;
        }

        const { product, option } = payload;

        // 기본 로깅
        console.log(`상품 ID: ${product?.registrationId}`);
        console.log(`옵션 번호: ${option?.optionNumber}`);

        // coupangDoc 정보 가져오기
        const coupangDoc = option?.coupangDoc || product?.coupangDoc;

        if (!coupangDoc || !coupangDoc.docId) {
          console.error('coupangDoc 정보가 없습니다. 업데이트할 수 없습니다.');
          return false;
        }

        console.log('coupangDoc:', coupangDoc)

        console.log(`coupangDoc ID: ${coupangDoc.docId}`);

        // 확장 프로그램에 메시지 전송 - 쿠플러스 안 표시(packageSource)만 뺀 coupangDoc 사본
        window.postMessage({
          type: 'UPDATE_ROCKET_REG_DOC',
          id: `update_${product.registrationId}_${option ? option.optionNumber : ''}_${Date.now()}`,
          data: {
            docId: coupangDoc.docId,
            body: coupangDocForSend(coupangDoc),
            suppliercode: context.state.user.suppliercode
          }
        }, '*');

        console.log('쿠팡 문서 업데이트 요청 완료');
        console.log('===== updateCoupangDocument 끝 =====');

        return true;
      } catch (error) {
        console.error('쿠팡 문서 업데이트 요청 중 오류:', error);
        return false;
      }
    },
    // index.js - updateOptionImage 액션 수정
    async updateOptionImage({ commit, state }, { registrationId, optionNumber, imageData }) {
      try {
        console.log(`옵션 ${optionNumber} 이미지 업데이트 시작:`, imageData);

        // 등록ID 가 없으면 여기서 던진다(옵션 번호만으로 딴 상품을 고치지 않게)
        const target = findOptionTarget(state.rocketProducts, registrationId, optionNumber);
        if (!target) throw new Error(`화면 목록의 상품 ${registrationId} 에서 옵션 ${optionNumber} 을 찾지 못했습니다`);

        // Vuex 상태 먼저 업데이트
        commit('UPDATE_OPTION_IMAGE', { registrationId, optionNumber, imageData });

        // 2. 해당 옵션의 coupangDoc 업데이트
        const option = target.product.options[target.optionIndex];

        if (option && option.coupangDoc && option.coupangDoc.jsonDocument &&
          option.coupangDoc.jsonDocument.length > 0) {
          const docObj = option.coupangDoc.jsonDocument[0];
          if (docObj.imagePage && docObj.imagePage.images) {
            // 메인 이미지 URL 업데이트 확인
            docObj.imagePage.images.mainImage = imageData.processedUrl;
            console.log(`옵션 ${optionNumber}의 coupangDoc 메인 이미지 설정: ${imageData.processedUrl}`);
          }
        }

        // 이 옵션의 대표이미지 칸만 부분 저장한다.
        // 상품 통째를 saveItems($set 전체)로 보내면, 같은 상품에서 함께 돌던 다른 작업(상세이미지 등)이
        // 그 사이 저장한 칸을 이 시점의 화면 사본으로 덮어쓰고, 응답으로 화면까지 되돌린다.
        const targetProduct = target.product;
        const optionIndex = target.optionIndex;
        const savedOption = targetProduct.options[optionIndex];
        const updateFields = {
          [`options.${optionIndex}.mainImageStatus`]: savedOption.mainImageStatus,
          mainImageStatus: targetProduct.mainImageStatus
        };
        const docObj = savedOption.coupangDoc && Array.isArray(savedOption.coupangDoc.jsonDocument) && savedOption.coupangDoc.jsonDocument[0];
        if (docObj && docObj.imagePage && docObj.imagePage.images) {
          updateFields[`options.${optionIndex}.coupangDoc.jsonDocument.0.imagePage.images.mainImage`] = docObj.imagePage.images.mainImage;
        }

        if (!targetProduct._id) {
          console.error('옵션 이미지 저장 실패 - 상품 _id 없음:', targetProduct.registrationId);
          throw new Error('상품 _id 가 없어 옵션 이미지를 저장할 수 없습니다');
        }

        const response = await axios.post('/api/aiRocketReg/updatePartial', {
          productId: targetProduct._id,
          updateFields
        });
        if (response.data.요청결과 !== 'success') {
          throw new Error(response.data.error || '옵션 이미지 서버 저장 실패');
        }
        console.log('서버 저장 후 processedImage:', savedOption.mainImageStatus && savedOption.mainImageStatus.processedImage);

        return true;
      } catch (error) {
        console.error('옵션 이미지 업데이트 중 오류:', error);
        throw error;
      }
    },

    // 목록용(_light) 문서를 완전 문서로 받아 store 에서 교체 — 무거운 칸(coupangDoc 등)을 쓰기 전에 부른다.
    // store 에 없는 id 도 받는다(넣지는 않고 돌려주기만 — 목록 기간 밖). 요청 순서대로 완전 문서 배열을 돌려준다.
    // 실패·빠진 id 가 있으면 throw. 묶음(20개)은 차례로 하나씩 보낸다(동시에 다 보내면 서버 메모리가 튄다).
    async ensureFullRocketProducts({ state, commit }, ids) {
      const want = uniqueIds(ids);
      const toFetch = pickLightIds(state.rocketProducts, want).filter(id => !fullFetchInflight.has(id));
      let prev = Promise.resolve();
      chunkIds(toFetch).forEach(chunk => {
        // 앞 묶음이 끝난 뒤(실패여도) 보낸다 — 결과는 이 묶음의 문서 배열
        const req = prev.catch(() => {}).then(() => axios.post('/api/aiRocketReg/getFull', { ids: chunk })).then(res => {
          const d = res && res.data;
          const got = (d && d['요청결과'] === 'ok' && Array.isArray(d.products)) ? d.products.map(addOriginDetailImages) : [];
          // 온 것은 먼저 끼우고(store 에 있는 id 만 — 뮤테이션이 없는 id 는 안 넣는다), 실패·빠진 id 가 있으면 그다음 throw
          got.forEach(p => commit('REPLACE_ROCKET_PRODUCT_FULL', p));
          checkFullResponse(d, chunk);
          return got;
        });
        prev = req;
        const done = () => chunk.forEach(id => { if (fullFetchInflight.get(id) === req) fullFetchInflight.delete(id); });
        req.then(done, done);
        chunk.forEach(id => fullFetchInflight.set(id, req));
      });
      const pending = [...new Set(want.map(id => fullFetchInflight.get(id)).filter(Boolean))];
      const fetched = new Map();
      try {
        const results = await Promise.all(pending);
        results.forEach(list => (list || []).forEach(p => fetched.set(String(p._id), p)));
      } catch (error) {
        console.error('완전 문서 불러오기 실패:', error);
        throw error;
      }
      // store 의 완전 문서 우선, 없거나 아직 목록용이면 받은 문서
      const byId = new Map((state.rocketProducts || []).map(p => [String(p && p._id), p]));
      return want.map(id => {
        const inStore = byId.get(id);
        if (inStore && !isLightDoc(inStore)) return inStore;
        return fetched.get(id) || inStore;
      }).filter(Boolean);
    },

    // 상품 부분 업데이트 액션
    async updateProductPartial({ commit }, { productId, updateFields }) {
      assertUpdateFieldsNotLight(updateFields); // 목록용 문서·옵션을 통째로 넣는 저장 금지
      try {
        console.log('🔄 updateProductPartial 호출됨, 상품ID:', productId);
        console.log('업데이트할 필드:', Object.keys(updateFields));

        // coupangDoc 필드가 있는지 확인하고 로깅
        if (updateFields.coupangDoc) {
          console.log('📋 coupangDoc 포함 여부: 포함됨');
          console.log('📊 coupangDoc 구조:', {
            version: updateFields.coupangDoc.version,
            scope: updateFields.coupangDoc.scope,
            hasJsonDocument: !!updateFields.coupangDoc.jsonDocument,
            jsonDocumentLength: updateFields.coupangDoc.jsonDocument?.length || 0
          });

          // coupangDoc 크기 확인 (너무 크면 문제가 될 수 있음)
          const coupangDocSize = JSON.stringify(updateFields.coupangDoc).length;
          console.log(`📦 coupangDoc 크기: ${coupangDocSize} 바이트 (${Math.round(coupangDocSize/1024)} KB)`);

          // 크기가 너무 크면 경고
          if (coupangDocSize > 5 * 1024 * 1024) { // 5MB 이상
            console.warn('⚠️ coupangDoc 크기가 매우 큽니다! 서버 요청 실패 가능성 있음');
          }
        } else {
          console.log('📋 coupangDoc 포함 여부: 포함되지 않음');
        }

        // 1. 우선 Vuex 상태 업데이트 (UI 즉시 반응)
        commit('updateProductPartial', { productId, updateFields });
        console.log('✅ Vuex 상태 부분 업데이트 완료');

        // 2. 서버에 저장
        console.log('💾 서버에 상품 부분 업데이트 시작...');
        console.log('📤 서버 요청 데이터:', {
          productId,
          updateFieldsCount: Object.keys(updateFields).length,
          updateFieldsKeys: Object.keys(updateFields)
        });
        console.log('🔍 [서버 전송] 전체 updateFields:', JSON.stringify(updateFields, null, 2));

        const response = await axios.post('/api/aiRocketReg/updatePartial', {
          productId,
          updateFields
        });
        console.log('📥 서버 응답:', response.data);

        // 응답 확인 및 오류 처리
        if (response.data.요청결과 !== 'success') {
          console.error('❌ 서버 저장 실패:', response.data.error || '상품 정보 부분 업데이트 실패');
          throw new Error(response.data.error || '상품 정보 부분 업데이트 실패');
        }

        console.log('✅ 상품 부분 업데이트 완료');
        return true;
      } catch (error) {
        console.error('상품 정보 부분 업데이트 중 오류:', error);
        throw error;
      }
    },

    // 상세 이미지 구조 단순화를 위한 액션
    async updateDetailImageStructure({ commit, state }, { productId, imageData }) {
      try {
        console.log('🔄 updateDetailImageStructure 호출됨, 상품ID:', productId);

        // 1. Vuex 상태 업데이트
        commit('updateDetailImageStructure', { productId, imageData });
        console.log('✅ Vuex 상태 업데이트 완료');

        // 2. 서버에 저장할 필드 준비
        const updateFields = {};

        if (imageData.originalDetailImages) {
          updateFields.originalDetailImages = imageData.originalDetailImages;
        }

        if (imageData.processedDetailImages) {
          updateFields.processedDetailImages = imageData.processedDetailImages;
        }

        if (imageData.finalDetailImage) {
          updateFields.finalDetailImage = imageData.finalDetailImage;

          // coupangDoc 업데이트 (있는 경우)
          const product = state.rocketProducts.find(p => p._id === productId);
          if (product && product.coupangDoc && product.coupangDoc.jsonDocument) {
            product.coupangDoc.jsonDocument.forEach((docItem, docIndex) => {
              if (docItem.imagePage && docItem.imagePage.details) {
                updateFields[`coupangDoc.jsonDocument.${docIndex}.imagePage.details.detailedImage`] = imageData.finalDetailImage;
                updateFields[`coupangDoc.jsonDocument.${docIndex}.imagePage.details.htmlProductDetailContent`] = "";
              }
            });
          }
        }

        if (imageData.detailImageStatus) {
          updateFields.detailImageStatus = imageData.detailImageStatus;
        }

        // 3. 서버에 저장
        if (Object.keys(updateFields).length > 0) {
          console.log('💾 서버에 상세 이미지 구조 업데이트 시작...');

          const response = await axios.post('/api/aiRocketReg/updatePartial', {
            productId,
            updateFields
          });

          // 응답 확인 및 오류 처리
          if (response.data.요청결과 !== 'success') {
            console.error('❌ 서버 저장 실패:', response.data.error || '상세 이미지 구조 업데이트 실패');
            throw new Error(response.data.error || '상세 이미지 구조 업데이트 실패');
          }

          console.log('✅ 상세 이미지 구조 업데이트 완료');
        }

        return true;
      } catch (error) {
        console.error('상세 이미지 구조 업데이트 중 오류:', error);
        throw error;
      }
    },

    // 작업 상태 설정
    setProcessing({ commit }, { isProcessing, message = '' }) {
      commit('SET_PROCESSING', isProcessing);
      commit('SET_PROGRESS_MESSAGE', message);
    },

    // 이미지에서 텍스트 제거 액션
    async removeTextFromImage({ dispatch }, imageUrl) {
      try {
        dispatch('setProcessing', {
          isProcessing: true,
          message: '이미지에서 텍스트 제거 중...'
        });

        const processedImageUrl = await imageService.removeTextFromImage(imageUrl);

        dispatch('setProcessing', { isProcessing: false });
        return processedImageUrl;
      } catch (error) {
        dispatch('setProcessing', { isProcessing: false });
        console.error('텍스트 제거 오류:', error);
        return imageUrl; // 오류 시 원본 URL 반환
      }
    },

    // 이미지 다운로드
    async downloadImage(_, url) {
      return await imageService.downloadImage(url);
    },

    // Blob을 Base64로 변환
    async blobToBase64(_, blob) {
      return await imageService.blobToBase64(blob);
    },

    // 이미지를 S3에 업로드
    async uploadImageToS3({ state }, payload) {
      try {
        // 파라미터 유효성 검사
        if (!payload || !payload.imageData) {
          console.error('uploadImageToS3 액션 오류: 이미지 데이터가 없습니다.', payload);
          throw new Error('이미지 데이터가 없습니다.');
        }

        // 디버깅 로그 추가
        console.log('S3 업로드 액션 호출:', {
          hasImageData: !!payload.imageData,
          filename: payload.filename || '(없음)',
          type: payload.type || '(없음)',
          companyId: state.user.companyid || 'default'
        });

        // 이미지 서비스 호출
        const result = await imageService.uploadImageToS3({
          ...payload,
          companyId: state.user.companyid || 'default'
        });

        // 응답 로깅 및 처리
        console.log('S3 업로드 액션 응답:', result);

        // 결과 반환 형식 표준화
        if (result) {
          if (typeof result === 'string') {
            // 문자열 URL이 반환된 경우 (이전 버전 호환)
            return { imageUrl: result, success: true };
          } else if (result.imageUrl) {
            // 객체 형태로 반환된 경우
            return result;
          }
        }

        // 실패 시 기본 응답
        return { success: false, message: '이미지 URL을 받지 못했습니다.' };
      } catch (error) {
        console.error('S3 업로드 액션 오류:', error);
        return { success: false, message: error.message || '업로드 중 오류가 발생했습니다.' };
      }
    },

    // 대표 이미지 처리
    async processMainImage({ dispatch, commit }, { product, option }) {
      try {
        dispatch('setProcessing', {
          isProcessing: true,
          message: '대표 이미지 처리 중...'
        });

        const result = await mainImageService.processMainImage(product, option);

        if (result) {
          commit('UPDATE_MAIN_IMAGE_RESULT', {
            productId: product.registrationId,
            optionNumber: option.optionNumber,
            result
          });
        }

        dispatch('setProcessing', { isProcessing: false });
        return result;
      } catch (error) {
        dispatch('setProcessing', { isProcessing: false });
        console.error('대표 이미지 처리 중 오류:', error);
        return null;
      }
    },

    // 추가 이미지 처리
    async processAdditionalImages({ dispatch, commit }, product) {
      try {
        dispatch('setProcessing', {
          isProcessing: true,
          message: '추가 이미지 처리 중...'
        });

        const result = await additionalImageService.processAdditionalImages(product);

        if (result) {
          commit('UPDATE_ADDITIONAL_IMAGE_RESULT', {
            productId: product.registrationId,
            result
          });
        }

        dispatch('setProcessing', { isProcessing: false });
        return result;
      } catch (error) {
        dispatch('setProcessing', { isProcessing: false });
        console.error('추가 이미지 처리 중 오류:', error);
        return null;
      }
    },

    // 상세 이미지 처리
    async processDetailImages({ dispatch, commit }, product) {
      try {
        dispatch('setProcessing', {
          isProcessing: true,
          message: '상세 이미지 처리 중...'
        });

        const result = await detailImageService.processDetailImages(product);

        if (result) {
          commit('UPDATE_DETAIL_IMAGE_RESULT', {
            productId: product.registrationId,
            result
          });
        }

        dispatch('setProcessing', { isProcessing: false });
        return result;
      } catch (error) {
        dispatch('setProcessing', { isProcessing: false });
        console.error('상세 이미지 처리 중 오류:', error);
        return null;
      }
    },

    // 한글 표시사항 처리
    async processKoreanLabels({ dispatch, commit }, product) {
      try {
        dispatch('setProcessing', {
          isProcessing: true,
          message: '한글 표시사항 처리 중...'
        });

        const result = await koreanLabelService.processKoreanLabels(product);

        if (result) {
          commit('UPDATE_KOREAN_LABEL_RESULT', {
            productId: product.registrationId,
            result
          });
        }

        dispatch('setProcessing', { isProcessing: false });
        return result;
      } catch (error) {
        dispatch('setProcessing', { isProcessing: false });
        console.error('한글 표시사항 처리 중 오류:', error);
        return null;
      }
    },

    // 가격 설정 처리
    async processPricing({ dispatch, commit }, { product, options }) {
      try {
        dispatch('setProcessing', {
          isProcessing: true,
          message: '가격 설정 처리 중...'
        });

        const result = await pricingService.processPricing(product, options);

        if (result) {
          commit('UPDATE_PRICING_RESULT', {
            productId: product.registrationId,
            result
          });
        }

        dispatch('setProcessing', { isProcessing: false });
        return result;
      } catch (error) {
        dispatch('setProcessing', { isProcessing: false });
        console.error('가격 설정 처리 중 오류:', error);
        return null;
      }
    },

    // SEO 설정 처리
    async processSeo({ dispatch, commit }, { product, options }) {
      try {
        dispatch('setProcessing', {
          isProcessing: true,
          message: 'SEO 설정 처리 중...'
        });

        const result = await seoService.processSeo(product, options);

        if (result) {
          commit('UPDATE_SEO_RESULT', {
            productId: product.registrationId,
            result
          });
        }

        dispatch('setProcessing', { isProcessing: false });
        return result;
      } catch (error) {
        dispatch('setProcessing', { isProcessing: false });
        console.error('SEO 설정 처리 중 오류:', error);
        return null;
      }
    },

    // 견적서 처리
    async processQuotation({ dispatch, commit }, { product, options }) {
      try {
        dispatch('setProcessing', {
          isProcessing: true,
          message: '견적서 작업 처리 중...'
        });

        const result = await quotationService.processQuotation(product, options);

        if (result) {
          commit('UPDATE_QUOTATION_RESULT', {
            productId: product.registrationId,
            result
          });
        }

        dispatch('setProcessing', { isProcessing: false });
        return result;
      } catch (error) {
        dispatch('setProcessing', { isProcessing: false });
        console.error('견적서 작업 처리 중 오류:', error);
        return null;
      }
    },

    // 모든 옵션의 메인 이미지 처리
    async processMainImageForAllOptions({ dispatch, commit }, product) {
      if (!product || !product.options || product.options.length === 0) {
        throw new Error('처리할 옵션이 없습니다.');
      }

      try {
        dispatch('setProcessing', {
          isProcessing: true,
          message: '모든 옵션의 대표 이미지 처리 중...'
        });

        // 워크플로우 서비스 호출
        const result = await workflowService.processMainImageForAllOptions(product);

        // 결과에 따라 상품 상태 업데이트
        const updatedProduct = { ...product };
        updatedProduct.mainImageStatus = result.status;

        // 상품 정보 업데이트
        commit('UPDATE_ROCKET_PRODUCT', updatedProduct);

        dispatch('setProcessing', { isProcessing: false });
        return result;
      } catch (error) {
        dispatch('setProcessing', { isProcessing: false });
        console.error('모든 옵션 메인 이미지 처리 중 오류:', error);
        throw error;
      }
    },

    // 단일 작업 실행 (일괄 처리용)
    async executeTask({ dispatch }, { product, taskType, options = {} }) {
      try {
        let result = null;

        switch (taskType) {
          case 'mainImage':
            result = await dispatch('processMainImageForAllOptions', product);
            break;
          case 'additionalImage':
            result = await dispatch('processAdditionalImages', product);
            break;
          case 'detailImage':
            result = await dispatch('processDetailImages', product);
            break;
          case 'koreanLabel':
            result = await dispatch('processKoreanLabels', product);
            break;
          case 'pricing':
            result = await dispatch('processPricing', { product, options });
            break;
          case 'seo':
            result = await dispatch('processSeo', { product, options });
            break;
          case 'quotation':
            result = await dispatch('processQuotation', { product, options });
            break;
          default:
            throw new Error(`알 수 없는 작업 유형: ${taskType}`);
        }

        return result;
      } catch (error) {
        console.error(`${taskType} 작업 실행 중 오류:`, error);
        throw error;
      }
    },

    // 테스트 요청 처리
    async testRequestExtension({ dispatch }, product) {
      try {
        dispatch('setProcessing', {
          isProcessing: true,
          message: 'AI 테스트 시작 중...'
        });

        // 테스트할 작업 목록
        const tasks = [
          'mainImage',
          'additionalImage',
          'detailImage',
          'koreanLabel',
          'seo',
          'pricing',
          'quotation'
        ];

        // 워크플로우 서비스로 처리
        const results = await workflowService.executeWorkflow(product, tasks);

        dispatch('setProcessing', { isProcessing: false });
        return results;
      } catch (error) {
        dispatch('setProcessing', { isProcessing: false });
        console.error('AI 테스트 중 오류:', error);
        throw error;
      }
    },

    // 카테고리 등록현황 데이터 가져오기
    async fetchCategoryListData({ commit, state, dispatch }, force = false) {
      try {
        // 이미 데이터가 있고 강제 가져오기가 아니면 기존 데이터 사용
        if (state.categoryListData.isLoaded && !force) {
          console.log('카테고리 등록현황 데이터가 이미 있어 기존 데이터를 사용합니다.');
          return state.categoryListData;
        }

        // 로딩 상태 설정
        dispatch('setProcessing', {
          isProcessing: true,
          message: '카테고리 등록현황 가져오는 중...'
        });

        // 서버에서 데이터 가져오기
        const response = await axios.post('/api/category/getcategorylist', {
          companyid: state.user.companyid
        });

        // 데이터 처리
        const { date, category } = response.data;

        // Vuex 상태 업데이트
        commit('SET_CATEGORY_LIST_DATA', { date, category });

        // 로딩 상태 해제
        dispatch('setProcessing', { isProcessing: false });

        console.log('카테고리 등록현황 데이터 가져오기 성공:', {
          lastUpdate: date,
          categoriesCount: category.length
        });

        return state.categoryListData;
      } catch (error) {
        // 로딩 상태 해제
        dispatch('setProcessing', { isProcessing: false });
        console.error('카테고리 등록현황 데이터 가져오기 오류:', error);
        throw error;
      }
    }
  },
  getters: {
    appName: state => { return state.appName },
    logo: state => { return state.logo },
    darklogo: state => { return state.darklogo },
    image1: state => { return state.user.image },
    name: state => { return state.user.name },
    accesshistory: state => { return state.user.accesshistory },
    email: state => { return state.user.email },
    companyid: state => { return state.user.companyid },
    expireDate: state => { return state.user.expireDate },
    suppliercode: state => { return state.user.suppliercode },
    image2: state => { return state.user.image2 },
    image3: state => { return state.user.image3 },
    dark: state => { return state.dark },
    // 로켓배송 관련 getters
    getRocketProductById: (state) => (id) => {
      return state.rocketProducts.find(product => product.registrationId === id) || null;
    },

    // 옵션 번호로 옵션 가져오기
    getOptionByNumber: (state) => (optionNumber) => {
      for (const product of state.rocketProducts) {
        if (!product.options) continue;

        const option = product.options.find(opt => opt.optionNumber === optionNumber);
        if (option) return option;
      }
      return null;
    },

    // 현재 선택된 옵션의 이미지 데이터 가져오기
    getCurrentOptionImageData: (state) => {
      if (!state.selectedOption) return null;
      return state.selectedOption.mainImageStatus || null;
    },

    // 작업 중인 이미지 데이터 가져오기
    getWorkingImageData: (state) => {
      return state.workingImageData;
    },

    // 카테고리 등록현황 데이터 가져오기
    getCategoryListData: (state) => {
      return state.categoryListData;
    },

    // 특정 상품의 작업 진행 상태 계산
    getProductWorkStatus: (state) => (productId) => {
      const product = state.rocketProducts.find(p => p.registrationId === productId);
      if (!product) return null;

      // 작업 상태 수집
      const statuses = {
        mainImage: product.mainImageStatus || 'pending',
        additionalImage: product.additionalImageStatus || 'pending',
        detailImage: product.detailImageStatus || 'pending',
        koreanLabel: product.koreanLabelStatus || 'pending',
        pricing: product.pricingStatus || 'pending',
        seo: product.seoStatus || 'pending',
        quotation: product.quotationStatus || 'pending'
      };

      // 완료된 작업 수 계산
      const completedTasks = Object.values(statuses).filter(
        status => status === 'completed'
      ).length;

      // 작업 총 개수
      const totalTasks = Object.keys(statuses).length;

      // 진행률 계산
      const progress = Math.round((completedTasks / totalTasks) * 100);

      return {
        statuses,
        completedTasks,
        totalTasks,
        progress
      };
    }
  },
  modules: {
  },
  // plugins: [createPersistedState({ paths: ["userStore"] })]
  // 어느 화면이 상품DB 를 채우든 근거값을 같이 받아 마진을 같은 식으로 맞춘다(#112)
  plugins: [store => store.subscribe(mutation => {
    if (mutation.type === 'growthdbupdate' && Array.isArray(mutation.payload) && mutation.payload.length) {
      loadGrowthCostBasis(store);
    }
  })]
})
